import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Delivery = {
  __typename?: 'Delivery';
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  deliveryItems?: Maybe<Array<Maybe<DeliveryItem>>>;
  deliveryNoteNumber?: Maybe<Scalars['String']>;
  fulfillmentRequestDate?: Maybe<FulfillmentRequestDate>;
  nikeSalesOrderTypeCode?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  salesOrderNumber?: Maybe<Scalars['String']>;
};

export type DeliveryItem = {
  __typename?: 'DeliveryItem';
  deliveryNoteItemNumber?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  sizeCode?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
};

export type DeliveryNote = {
  __typename?: 'DeliveryNote';
  fulfillmentRequestHeader?: Maybe<FulfillmentRequestHeader>;
  lastEventTimestamp?: Maybe<Scalars['String']>;
};

export type EddCalculation = {
  __typename?: 'EddCalculation';
  directDropIndicator?: Maybe<Scalars['Boolean']>;
  transitDays?: Maybe<Scalars['Int']>;
};

export type EnrichedDeliveryNote = {
  __typename?: 'EnrichedDeliveryNote';
  deliveryNote?: Maybe<DeliveryNote>;
  shipments?: Maybe<Array<Maybe<Shipment>>>;
};

export type EventSource = {
  __typename?: 'EventSource';
  processedTimestamp?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
};

export type FulfillmentRequestContact = {
  __typename?: 'FulfillmentRequestContact';
  dayPhoneNumber?: Maybe<Scalars['String']>;
  emailAddressText?: Maybe<Scalars['String']>;
};

export type FulfillmentRequestDate = {
  __typename?: 'FulfillmentRequestDate';
  cancelByDt?: Maybe<Scalars['String']>;
  customerOrderCreateTimestamp?: Maybe<Scalars['String']>;
  customerRequestTimestamp?: Maybe<Scalars['String']>;
  deliveryPlanScheduledDeliveryDate?: Maybe<Scalars['String']>;
  estimatedDeliveryTimestamp?: Maybe<Scalars['String']>;
  fulfillmentRequestCreateTimestamp?: Maybe<Scalars['String']>;
  plannedGoodsIssueTimestamp?: Maybe<Scalars['String']>;
  plannedPickingTimestamp?: Maybe<Scalars['String']>;
};

export type FulfillmentRequestHeader = {
  __typename?: 'FulfillmentRequestHeader';
  appointmentSchedulingIndicator?: Maybe<Scalars['Boolean']>;
  consumerRequestedMethod?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  customerDocumentRequiredIndicator?: Maybe<Scalars['Boolean']>;
  customerPOType?: Maybe<Scalars['String']>;
  directOrderDropIndicator?: Maybe<Scalars['Boolean']>;
  exportIndicator?: Maybe<Scalars['Boolean']>;
  fulfillmentMethod?: Maybe<Scalars['String']>;
  fulfillmentRequestDate?: Maybe<FulfillmentRequestDate>;
  fulfillmentRequestInstruction?: Maybe<Array<Maybe<FulfillmentRequestInstruction>>>;
  fulfillmentRequestItem?: Maybe<Array<Maybe<FulfillmentRequestItem>>>;
  fulfillmentRequestNumber?: Maybe<Scalars['String']>;
  fulfillmentRequestParty?: Maybe<Array<Maybe<FulfillmentRequestParty>>>;
  fulfillmentRequestReference?: Maybe<Array<Maybe<FulfillmentRequestReference>>>;
  fulfillmentRequestType?: Maybe<Scalars['String']>;
  immediateReleaseIndicator?: Maybe<Scalars['Boolean']>;
  incoTermsCode?: Maybe<Scalars['String']>;
  netTotalAmount?: Maybe<Scalars['String']>;
  orderGroupType?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  routeNumber?: Maybe<Scalars['String']>;
  salesDeliveryPriority?: Maybe<Scalars['String']>;
  salesOrganizationCode?: Maybe<Scalars['String']>;
  serviceLevelCode?: Maybe<Scalars['String']>;
  shipToAddressOverrideIndicator?: Maybe<Scalars['Boolean']>;
  shippingPointCode?: Maybe<Scalars['String']>;
  vendorCodeHubCode?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['String']>;
  volumeUOM?: Maybe<Scalars['String']>;
};

export type FulfillmentRequestInstruction = {
  __typename?: 'FulfillmentRequestInstruction';
  instruction1Text?: Maybe<Scalars['String']>;
  instructionCode?: Maybe<Scalars['String']>;
  vasIndicator?: Maybe<Scalars['Boolean']>;
};

export type FulfillmentRequestItem = {
  __typename?: 'FulfillmentRequestItem';
  alwaysAvailableIndicator?: Maybe<Scalars['Boolean']>;
  baseUnitQuantity?: Maybe<Scalars['Float']>;
  baseUnitQuantityUOM?: Maybe<Scalars['String']>;
  batchNumber?: Maybe<Scalars['String']>;
  channelClassCode?: Maybe<Scalars['String']>;
  customerAccountType?: Maybe<Scalars['String']>;
  customerBusinessTypeCode?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  fulfillmentRequestItemInstruction?: Maybe<Array<Maybe<FulfillmentRequestItemInstruction>>>;
  fulfillmentRequestItemReferenceOrder?: Maybe<Array<Maybe<FulfillmentRequestItemReferenceOrder>>>;
  fulfilmentRequestItemNbr?: Maybe<Scalars['String']>;
  grossWeight?: Maybe<Scalars['Float']>;
  gtin?: Maybe<Scalars['String']>;
  launchCode?: Maybe<Scalars['String']>;
  manufacturersSuggestedRetailPrice?: Maybe<Scalars['Float']>;
  materialAvailableDate?: Maybe<Scalars['String']>;
  materialGroupCode?: Maybe<Scalars['String']>;
  materialNumber?: Maybe<Scalars['String']>;
  netPriceAmount?: Maybe<Scalars['Float']>;
  netWeight?: Maybe<Scalars['Float']>;
  poRequiredIndicator?: Maybe<Scalars['Boolean']>;
  prepackCode?: Maybe<Scalars['String']>;
  productLifecycleCode?: Maybe<Scalars['String']>;
  promotionalIndicator?: Maybe<Scalars['Boolean']>;
  salesUnitQuantity?: Maybe<Scalars['Float']>;
  salesUnitQuantityUOM?: Maybe<Scalars['String']>;
  shippingPointCode?: Maybe<Scalars['String']>;
  sizeCode?: Maybe<Scalars['String']>;
  stockCategoryCode?: Maybe<Scalars['String']>;
  storageLocationCode?: Maybe<Scalars['String']>;
  weightUOM?: Maybe<Scalars['String']>;
};

export type FulfillmentRequestItemInstruction = {
  __typename?: 'FulfillmentRequestItemInstruction';
  instruction1Text?: Maybe<Scalars['String']>;
  instruction2Text?: Maybe<Scalars['String']>;
  instructionCode?: Maybe<Scalars['String']>;
  vasIndicator?: Maybe<Scalars['Boolean']>;
};

export type FulfillmentRequestItemReferenceOrder = {
  __typename?: 'FulfillmentRequestItemReferenceOrder';
  referenceItemTypeCode?: Maybe<Scalars['String']>;
  referenceItemTypeDescription?: Maybe<Scalars['String']>;
  referenceItemValue?: Maybe<Scalars['String']>;
};

export type FulfillmentRequestLocationAddress = {
  __typename?: 'FulfillmentRequestLocationAddress';
  addressLine1Text?: Maybe<Scalars['String']>;
  addressLine2Text?: Maybe<Scalars['String']>;
  addressLine3Text?: Maybe<Scalars['String']>;
  addressLine4Text?: Maybe<Scalars['String']>;
  addressLine5Text?: Maybe<Scalars['String']>;
  cityName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateProvinceCode?: Maybe<Scalars['String']>;
  transportationZone?: Maybe<Scalars['String']>;
};

export type FulfillmentRequestParty = {
  __typename?: 'FulfillmentRequestParty';
  fulfillmentRequestContact?: Maybe<FulfillmentRequestContact>;
  fulfillmentRequestLocationAddress?: Maybe<FulfillmentRequestLocationAddress>;
  partyIdentifier?: Maybe<Scalars['String']>;
  partyIdentifierType?: Maybe<Scalars['String']>;
  partyName1?: Maybe<Scalars['String']>;
  partyName2?: Maybe<Scalars['String']>;
  partyTypeCode?: Maybe<Scalars['String']>;
  transportationZone?: Maybe<Scalars['String']>;
};

export type FulfillmentRequestReference = {
  __typename?: 'FulfillmentRequestReference';
  referenceNumberTypeCode?: Maybe<Scalars['String']>;
  referenceNumberValue?: Maybe<Scalars['String']>;
};

export type GoodsHolder = {
  __typename?: 'GoodsHolder';
  actualDeliveryDate?: Maybe<Scalars['String']>;
  calculatedGoodsHolderItemCount?: Maybe<Scalars['Int']>;
  calculatedGoodsHolderStatusCode?: Maybe<Scalars['String']>;
  calculatedPackedQuantity?: Maybe<Scalars['Int']>;
  calculatedPlannedQuantity?: Maybe<Scalars['Int']>;
  containingGoodsHolderNumber?: Maybe<Scalars['String']>;
  containingGoodsHolderTypeCode?: Maybe<Scalars['String']>;
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  event_sources?: Maybe<Array<Maybe<EventSource>>>;
  goodsHolderItems?: Maybe<Array<Maybe<GoodsHolderItem>>>;
  goodsHolderItemsCount?: Maybe<Scalars['Int']>;
  goodsHolderMeasures?: Maybe<GoodsHolderMeasures>;
  goodsHolderNumber?: Maybe<Scalars['String']>;
  goodsHolderStatusCode?: Maybe<Scalars['String']>;
  goodsHolderTrackingNumber?: Maybe<Scalars['String']>;
  goodsHolderTypeCode?: Maybe<Scalars['String']>;
  idReferenceNumber?: Maybe<Scalars['String']>;
  nikeSalesOrderTypeCode?: Maybe<Scalars['String']>;
  packlistNumber?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  salesOrderNumber?: Maybe<Scalars['String']>;
  transportHolder?: Maybe<TransportHolder>;
  ttExceptions?: Maybe<Array<Maybe<TrackTraceException>>>;
};

export type GoodsHolderItem = {
  __typename?: 'GoodsHolderItem';
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  deliveryNoteItemNumber?: Maybe<Scalars['String']>;
  deliveryNoteNumber?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  iSegCode?: Maybe<Scalars['String']>;
  idReferenceNumber?: Maybe<Scalars['String']>;
  originCountryCode?: Maybe<Scalars['String']>;
  packedQuantity?: Maybe<Scalars['Int']>;
  plannedQuantity?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  salesOrderNumber?: Maybe<Scalars['String']>;
  sizeCode?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
};

export type GoodsHolderMeasures = {
  __typename?: 'GoodsHolderMeasures';
  chargeVolume?: Maybe<Measure>;
  chargeWeight?: Maybe<Measure>;
  grossVolume?: Maybe<Measure>;
  grossWeight?: Maybe<Measure>;
  height?: Maybe<Measure>;
  length?: Maybe<Measure>;
  netWeight?: Maybe<Measure>;
  width?: Maybe<Measure>;
};

export type Measure = {
  __typename?: 'Measure';
  measureUOM?: Maybe<Scalars['String']>;
  measureValue?: Maybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  getCustomerDetailsForDeliveryNote?: Maybe<DeliveryNote>;
  getCustomerDetailsForPacklist?: Maybe<Shipment>;
  getDeliveryNote?: Maybe<DeliveryNote>;
  getGoodsHolder?: Maybe<GoodsHolder>;
  getGoodsHoldersByPacklist: Array<GoodsHolder>;
  getShipment?: Maybe<Shipment>;
  getShipmentMaterials: Array<ShipmentMaterial>;
  getShipmentTrackAndTrace: Array<ShipmentTrackAndTrace>;
  getTrackAndTraceByGoodsHolder: Array<TrackAndTrace>;
  getTrackAndTraceByPacklist: Array<TrackAndTrace>;
  searchDeliveryNotes: Array<EnrichedDeliveryNote>;
  searchGoodsHolders: Array<GoodsHolder>;
  searchShipments: Array<Shipment>;
  searchShipmentsWithGoodsHolders: Array<Shipment>;
};


export type QueryGetCustomerDetailsForDeliveryNoteArgs = {
  deliveryNoteNumber: Scalars['String'];
};


export type QueryGetCustomerDetailsForPacklistArgs = {
  packlistNumber: Scalars['String'];
};


export type QueryGetDeliveryNoteArgs = {
  deliveryNoteNumber: Scalars['String'];
};


export type QueryGetGoodsHolderArgs = {
  goodsHolderNumber: Scalars['String'];
};


export type QueryGetGoodsHoldersByPacklistArgs = {
  from?: InputMaybe<Scalars['Int']>;
  packlistNumber: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetShipmentArgs = {
  packlistNumber: Scalars['String'];
};


export type QueryGetShipmentMaterialsArgs = {
  packlistNumber: Scalars['String'];
};


export type QueryGetShipmentTrackAndTraceArgs = {
  packlistNumber: Scalars['String'];
};


export type QueryGetTrackAndTraceByGoodsHolderArgs = {
  goodsHolderNumber: Scalars['String'];
};


export type QueryGetTrackAndTraceByPacklistArgs = {
  from?: InputMaybe<Scalars['Int']>;
  packlistNumber: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchDeliveryNotesArgs = {
  carrierHubs?: InputMaybe<Array<Scalars['String']>>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['Int']>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']>>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchGoodsHoldersArgs = {
  calculatedGoodsHolderStatusCodes?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['Int']>;
  goodsHolderNumbers?: InputMaybe<Array<Scalars['String']>>;
  goodsHolderTrackingNumbers?: InputMaybe<Array<Scalars['String']>>;
  packlistNumber: Scalars['String'];
  proNumbers?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Int']>;
  vendorAccessNumbers?: InputMaybe<Array<Scalars['String']>>;
};


export type QuerySearchShipmentsArgs = {
  actualDeliveryDateFrom?: InputMaybe<Array<Scalars['String']>>;
  actualDeliveryDateTo?: InputMaybe<Array<Scalars['String']>>;
  actualShippedTimestampFrom?: InputMaybe<Array<Scalars['String']>>;
  actualShippedTimestampTo?: InputMaybe<Array<Scalars['String']>>;
  calculatedShipmentStatusCodes?: InputMaybe<Array<Scalars['String']>>;
  carrierHubs?: InputMaybe<Array<Scalars['String']>>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['Int']>;
  goodsHolderNumbers?: InputMaybe<Array<Scalars['String']>>;
  hasTTExceptions?: InputMaybe<Array<Scalars['String']>>;
  orderTypeCodes?: InputMaybe<Array<Scalars['String']>>;
  packlistNumbers?: InputMaybe<Array<Scalars['String']>>;
  proNumbers?: InputMaybe<Array<Scalars['String']>>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']>>;
  shipToCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  shipToNames?: InputMaybe<Array<Scalars['String']>>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Int']>;
  transportHolderIdReferenceNumbers?: InputMaybe<Array<Scalars['String']>>;
  transportHolderLicensePlateNumbers?: InputMaybe<Array<Scalars['String']>>;
  transportHolderNumbers?: InputMaybe<Array<Scalars['String']>>;
  vendorAccessNumbers?: InputMaybe<Array<Scalars['String']>>;
};


export type QuerySearchShipmentsWithGoodsHoldersArgs = {
  actualDeliveryDateFrom?: InputMaybe<Array<Scalars['String']>>;
  actualDeliveryDateTo?: InputMaybe<Array<Scalars['String']>>;
  actualShippedTimestampFrom?: InputMaybe<Array<Scalars['String']>>;
  actualShippedTimestampTo?: InputMaybe<Array<Scalars['String']>>;
  calculatedShipmentStatusCodes?: InputMaybe<Array<Scalars['String']>>;
  carrierHubs?: InputMaybe<Array<Scalars['String']>>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['Int']>;
  goodsHolderNumbers?: InputMaybe<Array<Scalars['String']>>;
  hasTTExceptions?: InputMaybe<Array<Scalars['String']>>;
  orderTypeCodes?: InputMaybe<Array<Scalars['String']>>;
  packlistNumbers?: InputMaybe<Array<Scalars['String']>>;
  proNumbers?: InputMaybe<Array<Scalars['String']>>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']>>;
  shipToCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  shipToNames?: InputMaybe<Array<Scalars['String']>>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Int']>;
  transportHolderIdReferenceNumbers?: InputMaybe<Array<Scalars['String']>>;
  transportHolderLicensePlateNumbers?: InputMaybe<Array<Scalars['String']>>;
  transportHolderNumbers?: InputMaybe<Array<Scalars['String']>>;
  vendorAccessNumbers?: InputMaybe<Array<Scalars['String']>>;
};

export type Rebooking = {
  __typename?: 'Rebooking';
  iDPPlannedTimestamp?: Maybe<Scalars['String']>;
  lastRebookingTimestamp?: Maybe<Scalars['String']>;
  plannedDeliveryFromTimestamp?: Maybe<Scalars['String']>;
  plannedDeliveryToTimestamp?: Maybe<Scalars['String']>;
  rebookingType?: Maybe<RebookingType>;
};

export enum RebookingType {
  Hold = 'HOLD',
  Rebooking = 'REBOOKING'
}

export type ShipTo = {
  __typename?: 'ShipTo';
  addressLine1Text?: Maybe<Scalars['String']>;
  addressLine2Text?: Maybe<Scalars['String']>;
  addressLine3Text?: Maybe<Scalars['String']>;
  addressLine4Text?: Maybe<Scalars['String']>;
  addressOverrideIndicator?: Maybe<Scalars['Boolean']>;
  cityName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countyName?: Maybe<Scalars['String']>;
  emailAddressText?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  provinceStateRegionCode?: Maybe<Scalars['String']>;
  shipToCode?: Maybe<Scalars['String']>;
  shipToDropoffPointIdentifier?: Maybe<Scalars['String']>;
  shipToName?: Maybe<Scalars['String']>;
  shipToName2?: Maybe<Scalars['String']>;
  thirdPartyDepartmentLocationText?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Shipment = {
  __typename?: 'Shipment';
  actualDeliveryDate?: Maybe<Scalars['String']>;
  actualShipmentCloseTimestamp?: Maybe<Scalars['String']>;
  actualShipmentPlannedDate?: Maybe<Scalars['String']>;
  actualShipmentReadyTimestamp?: Maybe<Scalars['String']>;
  actualShippedTimestamp?: Maybe<Scalars['String']>;
  calculatedCmrGoodsHolderCount?: Maybe<Scalars['Int']>;
  calculatedCmrShipmentCount?: Maybe<Scalars['Int']>;
  calculatedEstimatedDeliveryTimestamp?: Maybe<Scalars['String']>;
  calculatedGoodsHolderCount?: Maybe<Scalars['Int']>;
  calculatedGoodsHolderItemCount?: Maybe<Scalars['Int']>;
  calculatedGrossVolume?: Maybe<Measure>;
  calculatedGrossWeight?: Maybe<Measure>;
  calculatedPackedQuantity?: Maybe<Scalars['Int']>;
  calculatedPlannedQuantity?: Maybe<Scalars['Int']>;
  calculatedShipmentStatusCode?: Maybe<Scalars['String']>;
  deliveries?: Maybe<Array<Maybe<Delivery>>>;
  deliveryInstructionText?: Maybe<Scalars['String']>;
  eddCalculation?: Maybe<EddCalculation>;
  estimatedDeliveryDate?: Maybe<Scalars['String']>;
  event_sources?: Maybe<Array<Maybe<EventSource>>>;
  exportIndicator?: Maybe<Scalars['Boolean']>;
  goodsHolderCount?: Maybe<Scalars['Int']>;
  goodsHolders?: Maybe<Array<Maybe<GoodsHolder>>>;
  iDPIndicator?: Maybe<Scalars['Boolean']>;
  iDPPlannedTimestamp?: Maybe<Scalars['String']>;
  idReferenceNumber?: Maybe<Scalars['String']>;
  lastEventTimestamp?: Maybe<Scalars['String']>;
  packlistNumber?: Maybe<Scalars['String']>;
  plannedDeliveryFromTimestamp?: Maybe<Scalars['String']>;
  plannedDeliveryToTimestamp?: Maybe<Scalars['String']>;
  plannedGoodsHolderCount?: Maybe<Scalars['Int']>;
  plannedShipmentCloseFromTimestamp?: Maybe<Scalars['String']>;
  plannedShipmentCloseToTimestamp?: Maybe<Scalars['String']>;
  plannedShipmentReadyTimestamp?: Maybe<Scalars['String']>;
  proNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  rebooking?: Maybe<Rebooking>;
  shipmentCancelTimestamp?: Maybe<Scalars['String']>;
  shipmentShipToAddress?: Maybe<ShipTo>;
  shipmentStatusCode?: Maybe<Scalars['String']>;
  shipmentTexts?: Maybe<Array<Maybe<ShipmentText>>>;
  shipmentVendors?: Maybe<Array<Maybe<ShipmentVendor>>>;
  shippingPointCode?: Maybe<Scalars['String']>;
  transportHolderGrossVolume?: Maybe<Measure>;
  transportHolderIdReferenceNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  transportHolderLicensePlateNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  transportHolderNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  transportHolderSealNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  transportHolderTypeSizeCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  ttExceptions?: Maybe<Array<Maybe<TrackTraceException>>>;
  updatedByIdentifier?: Maybe<Scalars['String']>;
  vendorAccessNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  xDockFlag?: Maybe<Scalars['Boolean']>;
};

export type ShipmentMaterial = {
  __typename?: 'ShipmentMaterial';
  customerPurchaseOrderNumber?: Maybe<Array<Maybe<Scalars['String']>>>;
  deliveryNoteNumber?: Maybe<Array<Maybe<Scalars['String']>>>;
  divisionCode?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCode?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Array<Maybe<Scalars['String']>>>;
  quantity?: Maybe<Scalars['Int']>;
  salesOrderNumber?: Maybe<Array<Maybe<Scalars['String']>>>;
  sizeCode?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
};

export type ShipmentText = {
  __typename?: 'ShipmentText';
  textDescription?: Maybe<Scalars['String']>;
  textIdentifier?: Maybe<Scalars['String']>;
  textTypeCode?: Maybe<Scalars['String']>;
};

export type ShipmentTrackAndTrace = {
  __typename?: 'ShipmentTrackAndTrace';
  count: Scalars['Int'];
  event: TandTEvent;
  goodsHolderNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceSystemName: Scalars['String'];
};

export type ShipmentVendor = {
  __typename?: 'ShipmentVendor';
  hubCode?: Maybe<Scalars['String']>;
  serviceLevelCode?: Maybe<Scalars['String']>;
  vendorCode?: Maybe<Scalars['String']>;
  vendorCodeHubCode?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
  vendorTypeCode?: Maybe<Scalars['String']>;
};

export type TandTAccessorialCodes = {
  __typename?: 'TandTAccessorialCodes';
  code?: Maybe<Scalars['String']>;
};

export type TandTEvent = {
  __typename?: 'TandTEvent';
  carrierStatusCode?: Maybe<Scalars['String']>;
  carrierStatusDescription?: Maybe<Scalars['String']>;
  eventLocalTimeZoneCode?: Maybe<Scalars['String']>;
  eventTimestamp?: Maybe<Scalars['String']>;
  intermediateStatusCode?: Maybe<Scalars['String']>;
  intermediateStatusDescription?: Maybe<Scalars['String']>;
  isException?: Maybe<Scalars['Boolean']>;
  lifecycleStatusCode?: Maybe<Scalars['String']>;
  lifecycleStatusDescription?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  reasonCodeDescription?: Maybe<Scalars['String']>;
};

export type TandTEventLocation = {
  __typename?: 'TandTEventLocation';
  cityName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  latitudeDecimalDegree?: Maybe<Scalars['String']>;
  locationCode?: Maybe<Scalars['String']>;
  longitudeDecimalDegree?: Maybe<Scalars['String']>;
  provinceStateRegionCode?: Maybe<Scalars['String']>;
};

export type TandTMessageControl = {
  __typename?: 'TandTMessageControl';
  messageCreatedTimestamp?: Maybe<Scalars['String']>;
  messageIdentifier?: Maybe<Scalars['String']>;
  sourceSystemName?: Maybe<Scalars['String']>;
};

export type TandTShipmentTrackTrace = {
  __typename?: 'TandTShipmentTrackTrace';
  accessorialCodes?: Maybe<TandTAccessorialCodes>;
  carrierServiceLevel?: Maybe<Scalars['String']>;
  childTrackingNumber?: Maybe<Scalars['String']>;
  deliveryAppointmentTimestamp?: Maybe<Scalars['String']>;
  estimatedDeliveryTimestamp?: Maybe<Scalars['String']>;
  event?: Maybe<TandTEvent>;
  eventLocation?: Maybe<TandTEventLocation>;
  goodsHolderNumber?: Maybe<Scalars['String']>;
  shipmentOriginCode?: Maybe<Scalars['String']>;
  shipmentReferenceNumber?: Maybe<Scalars['String']>;
  shipmentUltimateDestinationCountryCode?: Maybe<Scalars['String']>;
  storageFeesBeginTimestamp?: Maybe<Scalars['String']>;
  terminalArrivalTimestamp?: Maybe<Scalars['String']>;
  trackTraceTypeCode?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  tradingPartnerIdentifier?: Maybe<Scalars['String']>;
  vendor?: Maybe<TandTVendor>;
};

export type TandTVendor = {
  __typename?: 'TandTVendor';
  childVendorCode?: Maybe<Scalars['String']>;
  shipViaCode?: Maybe<Scalars['String']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
  vendorReferenceCode?: Maybe<Scalars['String']>;
};

export type TrackAndTrace = {
  __typename?: 'TrackAndTrace';
  event_sources?: Maybe<Array<Maybe<EventSource>>>;
  messageControl?: Maybe<TandTMessageControl>;
  shipmentTrackTrace?: Maybe<TandTShipmentTrackTrace>;
};

export type TrackTraceException = {
  __typename?: 'TrackTraceException';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type TransportHolder = {
  __typename?: 'TransportHolder';
  cmrTimestamp?: Maybe<Scalars['String']>;
  directDropIndicator?: Maybe<Scalars['Boolean']>;
  idReferenceNumber?: Maybe<Scalars['String']>;
  licensePlateNumber?: Maybe<Scalars['String']>;
  proNumber?: Maybe<Scalars['String']>;
  sealNumber?: Maybe<Scalars['String']>;
  transportHolderNumber?: Maybe<Scalars['String']>;
  vendorAccessNumber?: Maybe<Scalars['String']>;
};

export type GetGoodsHolderQueryVariables = Exact<{
  goodsHolderNumber: Scalars['String'];
}>;


export type GetGoodsHolderQuery = { __typename?: 'Query', getGoodsHolder?: { __typename?: 'GoodsHolder', packlistNumber?: string | null, goodsHolderNumber?: string | null, goodsHolderStatusCode?: string | null, goodsHolderTrackingNumber?: string | null, goodsHolderTypeCode?: string | null, idReferenceNumber?: string | null, nikeSalesOrderTypeCode?: string | null, purchaseOrderNumber?: string | null, salesOrderNumber?: string | null, containingGoodsHolderNumber?: string | null, containingGoodsHolderTypeCode?: string | null, actualDeliveryDate?: string | null, calculatedGoodsHolderStatusCode?: string | null, customerPurchaseOrderNumber?: string | null, calculatedPlannedQuantity?: number | null, calculatedPackedQuantity?: number | null, transportHolder?: { __typename?: 'TransportHolder', cmrTimestamp?: string | null, directDropIndicator?: boolean | null, proNumber?: string | null, transportHolderNumber?: string | null, vendorAccessNumber?: string | null } | null, goodsHolderItems?: Array<{ __typename?: 'GoodsHolderItem', divisionCode?: string | null, iSegCode?: string | null, idReferenceNumber?: string | null, originCountryCode?: string | null, packedQuantity?: number | null, plannedQuantity?: number | null, productCode?: string | null, purchaseOrderNumber?: string | null, customerPurchaseOrderNumber?: string | null, salesOrderNumber?: string | null, sizeCode?: string | null, upc?: string | null, deliveryNoteItemNumber?: string | null, deliveryNoteNumber?: string | null } | null> | null, goodsHolderMeasures?: { __typename?: 'GoodsHolderMeasures', grossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, grossWeight?: { __typename?: 'Measure', measureUOM?: string | null, measureValue?: number | null } | null } | null } | null, getTrackAndTraceByGoodsHolder: Array<{ __typename?: 'TrackAndTrace', messageControl?: { __typename?: 'TandTMessageControl', sourceSystemName?: string | null } | null, shipmentTrackTrace?: { __typename?: 'TandTShipmentTrackTrace', deliveryAppointmentTimestamp?: string | null, estimatedDeliveryTimestamp?: string | null, event?: { __typename?: 'TandTEvent', eventTimestamp?: string | null, lifecycleStatusCode?: string | null, lifecycleStatusDescription?: string | null, reasonCode?: string | null, reasonCodeDescription?: string | null, carrierStatusCode?: string | null, carrierStatusDescription?: string | null, intermediateStatusCode?: string | null, intermediateStatusDescription?: string | null, isException?: boolean | null } | null, vendor?: { __typename?: 'TandTVendor', shipViaCode?: string | null, standardCarrierAlphaCode?: string | null } | null } | null }> };

export type GetGoodsHoldersQueryVariables = Exact<{
  packlistNumber: Scalars['String'];
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetGoodsHoldersQuery = { __typename?: 'Query', getGoodsHoldersByPacklist: Array<{ __typename?: 'GoodsHolder', goodsHolderNumber?: string | null, goodsHolderTrackingNumber?: string | null, goodsHolderTypeCode?: string | null, goodsHolderStatusCode?: string | null, calculatedGoodsHolderStatusCode?: string | null, calculatedPlannedQuantity?: number | null, calculatedPackedQuantity?: number | null, nikeSalesOrderTypeCode?: string | null, purchaseOrderNumber?: string | null, actualDeliveryDate?: string | null, transportHolder?: { __typename?: 'TransportHolder', transportHolderNumber?: string | null, proNumber?: string | null, directDropIndicator?: boolean | null, cmrTimestamp?: string | null, vendorAccessNumber?: string | null } | null, goodsHolderMeasures?: { __typename?: 'GoodsHolderMeasures', grossWeight?: { __typename?: 'Measure', measureUOM?: string | null, measureValue?: number | null } | null, grossVolume?: { __typename?: 'Measure', measureUOM?: string | null, measureValue?: number | null } | null, height?: { __typename?: 'Measure', measureUOM?: string | null, measureValue?: number | null } | null, length?: { __typename?: 'Measure', measureUOM?: string | null, measureValue?: number | null } | null, width?: { __typename?: 'Measure', measureUOM?: string | null, measureValue?: number | null } | null } | null, ttExceptions?: Array<{ __typename?: 'TrackTraceException', code?: string | null, description?: string | null } | null> | null }> };

export type GetShipmentMaterialsQueryVariables = Exact<{
  packlistNumber: Scalars['String'];
}>;


export type GetShipmentMaterialsQuery = { __typename?: 'Query', getShipmentMaterials: Array<{ __typename?: 'ShipmentMaterial', productCode?: string | null, sizeCode?: string | null, quantity?: number | null, divisionCode?: Array<string | null> | null, deliveryNoteNumber?: Array<string | null> | null, purchaseOrderNumber?: Array<string | null> | null, salesOrderNumber?: Array<string | null> | null, customerPurchaseOrderNumber?: Array<string | null> | null, upc?: string | null }> };

export type SearchGoodsHoldersQueryVariables = Exact<{
  packlistNumber: Scalars['String'];
  goodsHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  proNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  vendorAccessNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  calculatedGoodsHolderStatusCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchGoodsHoldersQuery = { __typename?: 'Query', searchGoodsHolders: Array<{ __typename?: 'GoodsHolder', goodsHolderNumber?: string | null, goodsHolderTrackingNumber?: string | null, goodsHolderTypeCode?: string | null, goodsHolderStatusCode?: string | null, calculatedGoodsHolderStatusCode?: string | null, calculatedPlannedQuantity?: number | null, calculatedPackedQuantity?: number | null, nikeSalesOrderTypeCode?: string | null, purchaseOrderNumber?: string | null, actualDeliveryDate?: string | null, transportHolder?: { __typename?: 'TransportHolder', transportHolderNumber?: string | null, proNumber?: string | null, directDropIndicator?: boolean | null, cmrTimestamp?: string | null, vendorAccessNumber?: string | null } | null, goodsHolderMeasures?: { __typename?: 'GoodsHolderMeasures', grossWeight?: { __typename?: 'Measure', measureUOM?: string | null, measureValue?: number | null } | null, grossVolume?: { __typename?: 'Measure', measureUOM?: string | null, measureValue?: number | null } | null } | null, ttExceptions?: Array<{ __typename?: 'TrackTraceException', code?: string | null, description?: string | null } | null> | null }> };

export type SearchDeliveryNotesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchDeliveryNotesQuery = { __typename?: 'Query', searchDeliveryNotes: Array<{ __typename?: 'EnrichedDeliveryNote', deliveryNote?: { __typename?: 'DeliveryNote', fulfillmentRequestHeader?: { __typename?: 'FulfillmentRequestHeader', exportIndicator?: boolean | null, fulfillmentRequestNumber?: string | null, orderType?: string | null, shipToAddressOverrideIndicator?: boolean | null, shippingPointCode?: string | null, fulfillmentRequestDate?: { __typename?: 'FulfillmentRequestDate', estimatedDeliveryTimestamp?: string | null, deliveryPlanScheduledDeliveryDate?: string | null } | null, fulfillmentRequestItem?: Array<{ __typename?: 'FulfillmentRequestItem', salesUnitQuantity?: number | null } | null> | null, fulfillmentRequestParty?: Array<{ __typename?: 'FulfillmentRequestParty', partyIdentifier?: string | null, partyName1?: string | null, partyTypeCode?: string | null, fulfillmentRequestLocationAddress?: { __typename?: 'FulfillmentRequestLocationAddress', transportationZone?: string | null } | null } | null> | null, fulfillmentRequestReference?: Array<{ __typename?: 'FulfillmentRequestReference', referenceNumberTypeCode?: string | null, referenceNumberValue?: string | null } | null> | null } | null } | null, shipments?: Array<{ __typename?: 'Shipment', packlistNumber?: string | null, proNumbers?: Array<string | null> | null, shippingPointCode?: string | null, vendorAccessNumbers?: Array<string | null> | null, transportHolderNumbers?: Array<string | null> | null, calculatedCmrShipmentCount?: number | null, calculatedCmrGoodsHolderCount?: number | null, plannedShipmentReadyTimestamp?: string | null, transportHolderLicensePlateNumbers?: Array<string | null> | null, transportHolderSealNumbers?: Array<string | null> | null, transportHolderTypeSizeCodes?: Array<string | null> | null, transportHolderGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, deliveries?: Array<{ __typename?: 'Delivery', salesOrderNumber?: string | null } | null> | null } | null> | null }> };

export type SearchDeliveryNotesForExportQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchDeliveryNotesForExportQuery = { __typename?: 'Query', searchDeliveryNotes: Array<{ __typename?: 'EnrichedDeliveryNote', deliveryNote?: { __typename?: 'DeliveryNote', fulfillmentRequestHeader?: { __typename?: 'FulfillmentRequestHeader', exportIndicator?: boolean | null, fulfillmentRequestNumber?: string | null, orderType?: string | null, shipToAddressOverrideIndicator?: boolean | null, shippingPointCode?: string | null, fulfillmentRequestDate?: { __typename?: 'FulfillmentRequestDate', plannedGoodsIssueTimestamp?: string | null, deliveryPlanScheduledDeliveryDate?: string | null } | null, fulfillmentRequestItem?: Array<{ __typename?: 'FulfillmentRequestItem', salesUnitQuantity?: number | null } | null> | null, fulfillmentRequestInstruction?: Array<{ __typename?: 'FulfillmentRequestInstruction', instruction1Text?: string | null, vasIndicator?: boolean | null, instructionCode?: string | null } | null> | null, fulfillmentRequestParty?: Array<{ __typename?: 'FulfillmentRequestParty', partyIdentifier?: string | null, partyName1?: string | null, partyTypeCode?: string | null, fulfillmentRequestLocationAddress?: { __typename?: 'FulfillmentRequestLocationAddress', countryCode?: string | null, transportationZone?: string | null } | null } | null> | null, fulfillmentRequestReference?: Array<{ __typename?: 'FulfillmentRequestReference', referenceNumberTypeCode?: string | null, referenceNumberValue?: string | null } | null> | null } | null } | null, shipments?: Array<{ __typename?: 'Shipment', packlistNumber?: string | null, proNumbers?: Array<string | null> | null, shippingPointCode?: string | null, deliveries?: Array<{ __typename?: 'Delivery', salesOrderNumber?: string | null } | null> | null } | null> | null }> };

export type SearchDeliveryNotesWithCustomerDetailsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchDeliveryNotesWithCustomerDetailsQuery = { __typename?: 'Query', searchDeliveryNotes: Array<{ __typename?: 'EnrichedDeliveryNote', deliveryNote?: { __typename?: 'DeliveryNote', fulfillmentRequestHeader?: { __typename?: 'FulfillmentRequestHeader', exportIndicator?: boolean | null, fulfillmentRequestNumber?: string | null, orderType?: string | null, shipToAddressOverrideIndicator?: boolean | null, shippingPointCode?: string | null, fulfillmentRequestDate?: { __typename?: 'FulfillmentRequestDate', estimatedDeliveryTimestamp?: string | null, deliveryPlanScheduledDeliveryDate?: string | null } | null, fulfillmentRequestItem?: Array<{ __typename?: 'FulfillmentRequestItem', salesUnitQuantity?: number | null } | null> | null, fulfillmentRequestParty?: Array<{ __typename?: 'FulfillmentRequestParty', partyName1?: string | null, partyName2?: string | null, partyIdentifier?: string | null, partyTypeCode?: string | null, fulfillmentRequestLocationAddress?: { __typename?: 'FulfillmentRequestLocationAddress', addressLine1Text?: string | null, addressLine2Text?: string | null, addressLine3Text?: string | null, addressLine4Text?: string | null, addressLine5Text?: string | null, cityName?: string | null, countryCode?: string | null, languageCode?: string | null, postalCode?: string | null, stateProvinceCode?: string | null, transportationZone?: string | null } | null, fulfillmentRequestContact?: { __typename?: 'FulfillmentRequestContact', dayPhoneNumber?: string | null, emailAddressText?: string | null } | null } | null> | null, fulfillmentRequestReference?: Array<{ __typename?: 'FulfillmentRequestReference', referenceNumberTypeCode?: string | null, referenceNumberValue?: string | null } | null> | null } | null } | null, shipments?: Array<{ __typename?: 'Shipment', packlistNumber?: string | null, proNumbers?: Array<string | null> | null, shippingPointCode?: string | null, vendorAccessNumbers?: Array<string | null> | null, transportHolderNumbers?: Array<string | null> | null, calculatedCmrShipmentCount?: number | null, calculatedCmrGoodsHolderCount?: number | null, plannedShipmentReadyTimestamp?: string | null, transportHolderLicensePlateNumbers?: Array<string | null> | null, transportHolderSealNumbers?: Array<string | null> | null, transportHolderTypeSizeCodes?: Array<string | null> | null, transportHolderGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, deliveries?: Array<{ __typename?: 'Delivery', salesOrderNumber?: string | null } | null> | null } | null> | null }> };

export type GetDeliveryNoteQueryVariables = Exact<{
  deliveryNoteNumber: Scalars['String'];
}>;


export type GetDeliveryNoteQuery = { __typename?: 'Query', getDeliveryNote?: { __typename?: 'DeliveryNote', fulfillmentRequestHeader?: { __typename?: 'FulfillmentRequestHeader', fulfillmentRequestParty?: Array<{ __typename?: 'FulfillmentRequestParty', partyName1?: string | null, partyName2?: string | null, partyIdentifier?: string | null, fulfillmentRequestLocationAddress?: { __typename?: 'FulfillmentRequestLocationAddress', addressLine1Text?: string | null, addressLine2Text?: string | null, addressLine3Text?: string | null, addressLine4Text?: string | null, addressLine5Text?: string | null, cityName?: string | null, countryCode?: string | null, postalCode?: string | null, languageCode?: string | null, stateProvinceCode?: string | null, transportationZone?: string | null } | null, fulfillmentRequestContact?: { __typename?: 'FulfillmentRequestContact', dayPhoneNumber?: string | null, emailAddressText?: string | null } | null } | null> | null } | null } | null };

export type GetCustomerDetailsForPacklistQueryVariables = Exact<{
  packlistNumber: Scalars['String'];
}>;


export type GetCustomerDetailsForPacklistQuery = { __typename?: 'Query', getCustomerDetailsForPacklist?: { __typename?: 'Shipment', packlistNumber?: string | null, shipmentShipToAddress?: { __typename?: 'ShipTo', shipToCode?: string | null, shipToName?: string | null, shipToName2?: string | null, countryCode?: string | null, addressLine1Text?: string | null, addressLine2Text?: string | null, addressLine3Text?: string | null, addressLine4Text?: string | null, cityName?: string | null, zipCode?: string | null, provinceStateRegionCode?: string | null, emailAddressText?: string | null, phoneNumber?: string | null, languageCode?: string | null, countyName?: string | null, shipToDropoffPointIdentifier?: string | null, thirdPartyDepartmentLocationText?: string | null } | null } | null };

export type GetShipmentQueryVariables = Exact<{
  packlistNumber: Scalars['String'];
}>;


export type GetShipmentQuery = { __typename?: 'Query', getShipment?: { __typename?: 'Shipment', packlistNumber?: string | null, idReferenceNumber?: string | null, iDPIndicator?: boolean | null, iDPPlannedTimestamp?: string | null, deliveryInstructionText?: string | null, estimatedDeliveryDate?: string | null, plannedShipmentReadyTimestamp?: string | null, actualShipmentPlannedDate?: string | null, actualShipmentReadyTimestamp?: string | null, plannedShipmentCloseFromTimestamp?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null, actualShipmentCloseTimestamp?: string | null, actualDeliveryDate?: string | null, actualShippedTimestamp?: string | null, plannedGoodsHolderCount?: number | null, calculatedPlannedQuantity?: number | null, calculatedGoodsHolderCount?: number | null, calculatedPackedQuantity?: number | null, calculatedEstimatedDeliveryTimestamp?: string | null, shipmentCancelTimestamp?: string | null, xDockFlag?: boolean | null, proNumbers?: Array<string | null> | null, vendorAccessNumbers?: Array<string | null> | null, transportHolderNumbers?: Array<string | null> | null, calculatedCmrShipmentCount?: number | null, calculatedCmrGoodsHolderCount?: number | null, transportHolderLicensePlateNumbers?: Array<string | null> | null, transportHolderSealNumbers?: Array<string | null> | null, transportHolderTypeSizeCodes?: Array<string | null> | null, transportHolderIdReferenceNumbers?: Array<string | null> | null, shipmentStatusCode?: string | null, calculatedShipmentStatusCode?: string | null, shippingPointCode?: string | null, exportIndicator?: boolean | null, deliveries?: Array<{ __typename?: 'Delivery', deliveryNoteNumber?: string | null, customerPurchaseOrderNumber?: string | null, nikeSalesOrderTypeCode?: string | null, purchaseOrderNumber?: string | null, salesOrderNumber?: string | null, fulfillmentRequestDate?: { __typename?: 'FulfillmentRequestDate', cancelByDt?: string | null, estimatedDeliveryTimestamp?: string | null } | null } | null> | null, calculatedGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, calculatedGrossWeight?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, eddCalculation?: { __typename?: 'EddCalculation', transitDays?: number | null } | null, transportHolderGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, shipmentShipToAddress?: { __typename?: 'ShipTo', shipToCode?: string | null, shipToName?: string | null, shipToName2?: string | null, countryCode?: string | null, addressOverrideIndicator?: boolean | null } | null, shipmentVendors?: Array<{ __typename?: 'ShipmentVendor', hubCode?: string | null, serviceLevelCode?: string | null, vendorCode?: string | null, vendorName?: string | null, vendorTypeCode?: string | null } | null> | null, rebooking?: { __typename?: 'Rebooking', rebookingType?: RebookingType | null, iDPPlannedTimestamp?: string | null, lastRebookingTimestamp?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null } | null, ttExceptions?: Array<{ __typename?: 'TrackTraceException', code?: string | null, description?: string | null } | null> | null, event_sources?: Array<{ __typename?: 'EventSource', s3Key?: string | null, processedTimestamp?: string | null } | null> | null } | null };

export type SearchShipmentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  packlistNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  goodsHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  proNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  vendorAccessNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  calculatedShipmentStatusCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  carrierHubs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderTypeCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hasTTExceptions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderLicensePlateNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderIdReferenceNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchShipmentsQuery = { __typename?: 'Query', searchShipments: Array<{ __typename?: 'Shipment', packlistNumber?: string | null, proNumbers?: Array<string | null> | null, vendorAccessNumbers?: Array<string | null> | null, transportHolderNumbers?: Array<string | null> | null, xDockFlag?: boolean | null, calculatedCmrShipmentCount?: number | null, calculatedCmrGoodsHolderCount?: number | null, plannedShipmentReadyTimestamp?: string | null, transportHolderLicensePlateNumbers?: Array<string | null> | null, transportHolderSealNumbers?: Array<string | null> | null, transportHolderTypeSizeCodes?: Array<string | null> | null, transportHolderIdReferenceNumbers?: Array<string | null> | null, shippingPointCode?: string | null, plannedGoodsHolderCount?: number | null, calculatedGoodsHolderCount?: number | null, calculatedPlannedQuantity?: number | null, calculatedPackedQuantity?: number | null, calculatedShipmentStatusCode?: string | null, estimatedDeliveryDate?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null, iDPIndicator?: boolean | null, iDPPlannedTimestamp?: string | null, calculatedEstimatedDeliveryTimestamp?: string | null, actualShippedTimestamp?: string | null, actualDeliveryDate?: string | null, shipmentCancelTimestamp?: string | null, updatedByIdentifier?: string | null, transportHolderGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, shipmentShipToAddress?: { __typename?: 'ShipTo', shipToCode?: string | null, shipToName?: string | null } | null, deliveries?: Array<{ __typename?: 'Delivery', deliveryNoteNumber?: string | null, salesOrderNumber?: string | null } | null> | null, eddCalculation?: { __typename?: 'EddCalculation', transitDays?: number | null } | null, calculatedGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, calculatedGrossWeight?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, shipmentVendors?: Array<{ __typename?: 'ShipmentVendor', hubCode?: string | null, serviceLevelCode?: string | null, vendorCode?: string | null, vendorName?: string | null, vendorTypeCode?: string | null } | null> | null, shipmentTexts?: Array<{ __typename?: 'ShipmentText', textTypeCode?: string | null, textIdentifier?: string | null, textDescription?: string | null } | null> | null, ttExceptions?: Array<{ __typename?: 'TrackTraceException', code?: string | null, description?: string | null } | null> | null, rebooking?: { __typename?: 'Rebooking', rebookingType?: RebookingType | null, iDPPlannedTimestamp?: string | null, lastRebookingTimestamp?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null } | null }> };

export type SearchShipmentsForExportQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  packlistNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  goodsHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  proNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  vendorAccessNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  calculatedShipmentStatusCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  carrierHubs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderTypeCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hasTTExceptions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderLicensePlateNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderIdReferenceNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchShipmentsForExportQuery = { __typename?: 'Query', searchShipments: Array<{ __typename?: 'Shipment', iDPIndicator?: boolean | null, iDPPlannedTimestamp?: string | null, packlistNumber?: string | null, proNumbers?: Array<string | null> | null, vendorAccessNumbers?: Array<string | null> | null, transportHolderNumbers?: Array<string | null> | null, transportHolderLicensePlateNumbers?: Array<string | null> | null, transportHolderSealNumbers?: Array<string | null> | null, transportHolderIdReferenceNumbers?: Array<string | null> | null, exportIndicator?: boolean | null, xDockFlag?: boolean | null, shippingPointCode?: string | null, plannedGoodsHolderCount?: number | null, calculatedGoodsHolderCount?: number | null, calculatedPlannedQuantity?: number | null, calculatedPackedQuantity?: number | null, calculatedShipmentStatusCode?: string | null, deliveryInstructionText?: string | null, estimatedDeliveryDate?: string | null, actualDeliveryDate?: string | null, actualShippedTimestamp?: string | null, actualShipmentPlannedDate?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null, plannedShipmentReadyTimestamp?: string | null, calculatedEstimatedDeliveryTimestamp?: string | null, shipmentCancelTimestamp?: string | null, updatedByIdentifier?: string | null, shipmentShipToAddress?: { __typename?: 'ShipTo', shipToCode?: string | null, shipToName?: string | null, countryCode?: string | null, addressOverrideIndicator?: boolean | null } | null, deliveries?: Array<{ __typename?: 'Delivery', deliveryNoteNumber?: string | null, salesOrderNumber?: string | null, purchaseOrderNumber?: string | null, nikeSalesOrderTypeCode?: string | null } | null> | null, shipmentTexts?: Array<{ __typename?: 'ShipmentText', textTypeCode?: string | null, textIdentifier?: string | null, textDescription?: string | null } | null> | null, calculatedGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, calculatedGrossWeight?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, eddCalculation?: { __typename?: 'EddCalculation', transitDays?: number | null } | null, shipmentVendors?: Array<{ __typename?: 'ShipmentVendor', hubCode?: string | null, serviceLevelCode?: string | null, vendorCode?: string | null, vendorName?: string | null, vendorTypeCode?: string | null } | null> | null, ttExceptions?: Array<{ __typename?: 'TrackTraceException', code?: string | null, description?: string | null } | null> | null, rebooking?: { __typename?: 'Rebooking', rebookingType?: RebookingType | null, iDPPlannedTimestamp?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null } | null }> };

export type SearchShipmentsForExportWithCustomerDetailsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  packlistNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  goodsHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  proNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  vendorAccessNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  calculatedShipmentStatusCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  carrierHubs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderTypeCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hasTTExceptions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderLicensePlateNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderIdReferenceNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchShipmentsForExportWithCustomerDetailsQuery = { __typename?: 'Query', searchShipments: Array<{ __typename?: 'Shipment', iDPIndicator?: boolean | null, iDPPlannedTimestamp?: string | null, packlistNumber?: string | null, proNumbers?: Array<string | null> | null, vendorAccessNumbers?: Array<string | null> | null, transportHolderNumbers?: Array<string | null> | null, transportHolderLicensePlateNumbers?: Array<string | null> | null, transportHolderSealNumbers?: Array<string | null> | null, transportHolderIdReferenceNumbers?: Array<string | null> | null, xDockFlag?: boolean | null, exportIndicator?: boolean | null, shippingPointCode?: string | null, plannedGoodsHolderCount?: number | null, calculatedGoodsHolderCount?: number | null, calculatedPlannedQuantity?: number | null, calculatedPackedQuantity?: number | null, calculatedShipmentStatusCode?: string | null, deliveryInstructionText?: string | null, estimatedDeliveryDate?: string | null, actualDeliveryDate?: string | null, actualShippedTimestamp?: string | null, actualShipmentPlannedDate?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null, plannedShipmentReadyTimestamp?: string | null, calculatedEstimatedDeliveryTimestamp?: string | null, shipmentCancelTimestamp?: string | null, updatedByIdentifier?: string | null, shipmentShipToAddress?: { __typename?: 'ShipTo', shipToCode?: string | null, shipToName?: string | null, countryCode?: string | null, addressLine1Text?: string | null, addressLine2Text?: string | null, addressLine3Text?: string | null, cityName?: string | null, zipCode?: string | null, emailAddressText?: string | null, phoneNumber?: string | null, addressOverrideIndicator?: boolean | null } | null, deliveries?: Array<{ __typename?: 'Delivery', deliveryNoteNumber?: string | null, salesOrderNumber?: string | null, purchaseOrderNumber?: string | null, nikeSalesOrderTypeCode?: string | null } | null> | null, shipmentTexts?: Array<{ __typename?: 'ShipmentText', textTypeCode?: string | null, textIdentifier?: string | null, textDescription?: string | null } | null> | null, calculatedGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, calculatedGrossWeight?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, eddCalculation?: { __typename?: 'EddCalculation', transitDays?: number | null } | null, shipmentVendors?: Array<{ __typename?: 'ShipmentVendor', hubCode?: string | null, serviceLevelCode?: string | null, vendorCode?: string | null, vendorName?: string | null, vendorTypeCode?: string | null } | null> | null, ttExceptions?: Array<{ __typename?: 'TrackTraceException', code?: string | null, description?: string | null } | null> | null, rebooking?: { __typename?: 'Rebooking', rebookingType?: RebookingType | null, iDPPlannedTimestamp?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null } | null }> };

export type SearchShipmentsWithCustomerDetailsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  packlistNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  goodsHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  proNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  vendorAccessNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  calculatedShipmentStatusCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  carrierHubs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderTypeCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hasTTExceptions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderLicensePlateNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderIdReferenceNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchShipmentsWithCustomerDetailsQuery = { __typename?: 'Query', searchShipments: Array<{ __typename?: 'Shipment', iDPIndicator?: boolean | null, iDPPlannedTimestamp?: string | null, packlistNumber?: string | null, proNumbers?: Array<string | null> | null, vendorAccessNumbers?: Array<string | null> | null, transportHolderNumbers?: Array<string | null> | null, calculatedCmrShipmentCount?: number | null, calculatedCmrGoodsHolderCount?: number | null, plannedShipmentReadyTimestamp?: string | null, transportHolderLicensePlateNumbers?: Array<string | null> | null, transportHolderSealNumbers?: Array<string | null> | null, transportHolderTypeSizeCodes?: Array<string | null> | null, transportHolderIdReferenceNumbers?: Array<string | null> | null, xDockFlag?: boolean | null, exportIndicator?: boolean | null, shippingPointCode?: string | null, plannedGoodsHolderCount?: number | null, calculatedGoodsHolderCount?: number | null, calculatedPlannedQuantity?: number | null, calculatedPackedQuantity?: number | null, calculatedShipmentStatusCode?: string | null, deliveryInstructionText?: string | null, estimatedDeliveryDate?: string | null, actualDeliveryDate?: string | null, actualShippedTimestamp?: string | null, actualShipmentPlannedDate?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null, calculatedEstimatedDeliveryTimestamp?: string | null, shipmentCancelTimestamp?: string | null, updatedByIdentifier?: string | null, transportHolderGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, shipmentShipToAddress?: { __typename?: 'ShipTo', shipToCode?: string | null, shipToName?: string | null, shipToName2?: string | null, countryCode?: string | null, addressLine1Text?: string | null, addressLine2Text?: string | null, addressLine3Text?: string | null, addressLine4Text?: string | null, cityName?: string | null, zipCode?: string | null, provinceStateRegionCode?: string | null, emailAddressText?: string | null, phoneNumber?: string | null, languageCode?: string | null, countyName?: string | null, shipToDropoffPointIdentifier?: string | null, thirdPartyDepartmentLocationText?: string | null } | null, deliveries?: Array<{ __typename?: 'Delivery', deliveryNoteNumber?: string | null, salesOrderNumber?: string | null, purchaseOrderNumber?: string | null, nikeSalesOrderTypeCode?: string | null } | null> | null, shipmentTexts?: Array<{ __typename?: 'ShipmentText', textTypeCode?: string | null, textIdentifier?: string | null, textDescription?: string | null } | null> | null, calculatedGrossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, calculatedGrossWeight?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, eddCalculation?: { __typename?: 'EddCalculation', transitDays?: number | null } | null, shipmentVendors?: Array<{ __typename?: 'ShipmentVendor', hubCode?: string | null, serviceLevelCode?: string | null, vendorCode?: string | null, vendorName?: string | null, vendorTypeCode?: string | null } | null> | null, ttExceptions?: Array<{ __typename?: 'TrackTraceException', code?: string | null, description?: string | null } | null> | null, rebooking?: { __typename?: 'Rebooking', rebookingType?: RebookingType | null, iDPPlannedTimestamp?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null } | null }> };

export type SearchShipmentsWithGoodsHoldersForExportQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  packlistNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  salesOrderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryNoteNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  goodsHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  proNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  vendorAccessNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  calculatedShipmentStatusCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  carrierHubs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipToCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingPointCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderTypeCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualShippedTimestampTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateFrom?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  actualDeliveryDateTo?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hasTTExceptions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderLicensePlateNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportHolderIdReferenceNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchShipmentsWithGoodsHoldersForExportQuery = { __typename?: 'Query', searchShipmentsWithGoodsHolders: Array<{ __typename?: 'Shipment', iDPIndicator?: boolean | null, packlistNumber?: string | null, proNumbers?: Array<string | null> | null, vendorAccessNumbers?: Array<string | null> | null, transportHolderNumbers?: Array<string | null> | null, transportHolderLicensePlateNumbers?: Array<string | null> | null, transportHolderSealNumbers?: Array<string | null> | null, transportHolderIdReferenceNumbers?: Array<string | null> | null, shippingPointCode?: string | null, estimatedDeliveryDate?: string | null, actualShippedTimestamp?: string | null, actualShipmentPlannedDate?: string | null, iDPPlannedTimestamp?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null, plannedShipmentReadyTimestamp?: string | null, calculatedEstimatedDeliveryTimestamp?: string | null, actualDeliveryDate?: string | null, shipmentShipToAddress?: { __typename?: 'ShipTo', shipToCode?: string | null, shipToName?: string | null, countryCode?: string | null, addressOverrideIndicator?: boolean | null } | null, goodsHolders?: Array<{ __typename?: 'GoodsHolder', goodsHolderNumber?: string | null, goodsHolderTrackingNumber?: string | null, salesOrderNumber?: string | null, purchaseOrderNumber?: string | null, calculatedGoodsHolderStatusCode?: string | null, calculatedPackedQuantity?: number | null, calculatedPlannedQuantity?: number | null, goodsHolderItems?: Array<{ __typename?: 'GoodsHolderItem', deliveryNoteNumber?: string | null } | null> | null, goodsHolderMeasures?: { __typename?: 'GoodsHolderMeasures', grossWeight?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null, grossVolume?: { __typename?: 'Measure', measureValue?: number | null, measureUOM?: string | null } | null } | null, transportHolder?: { __typename?: 'TransportHolder', proNumber?: string | null, transportHolderNumber?: string | null, vendorAccessNumber?: string | null, directDropIndicator?: boolean | null, cmrTimestamp?: string | null, sealNumber?: string | null, licensePlateNumber?: string | null, idReferenceNumber?: string | null } | null } | null> | null, shipmentVendors?: Array<{ __typename?: 'ShipmentVendor', hubCode?: string | null, vendorCode?: string | null } | null> | null, rebooking?: { __typename?: 'Rebooking', rebookingType?: RebookingType | null, iDPPlannedTimestamp?: string | null, plannedDeliveryFromTimestamp?: string | null, plannedDeliveryToTimestamp?: string | null } | null }> };

export type GetShipmentTrackAndTraceQueryVariables = Exact<{
  packlistNumber: Scalars['String'];
}>;


export type GetShipmentTrackAndTraceQuery = { __typename?: 'Query', getShipmentTrackAndTrace: Array<{ __typename?: 'ShipmentTrackAndTrace', sourceSystemName: string, goodsHolderNumbers?: Array<string | null> | null, count: number, event: { __typename?: 'TandTEvent', eventTimestamp?: string | null, carrierStatusDescription?: string | null, intermediateStatusCode?: string | null, intermediateStatusDescription?: string | null, isException?: boolean | null } }> };


export const GetGoodsHolderDocument = gql`
    query getGoodsHolder($goodsHolderNumber: String!) {
  getGoodsHolder(goodsHolderNumber: $goodsHolderNumber) {
    packlistNumber
    goodsHolderNumber
    goodsHolderStatusCode
    goodsHolderTrackingNumber
    goodsHolderTypeCode
    idReferenceNumber
    nikeSalesOrderTypeCode
    purchaseOrderNumber
    salesOrderNumber
    containingGoodsHolderNumber
    containingGoodsHolderTypeCode
    transportHolder {
      cmrTimestamp
      directDropIndicator
      proNumber
      transportHolderNumber
      vendorAccessNumber
    }
    actualDeliveryDate
    calculatedGoodsHolderStatusCode
    customerPurchaseOrderNumber
    goodsHolderItems {
      divisionCode
      iSegCode
      idReferenceNumber
      originCountryCode
      packedQuantity
      plannedQuantity
      productCode
      purchaseOrderNumber
      customerPurchaseOrderNumber
      salesOrderNumber
      sizeCode
      upc
      deliveryNoteItemNumber
      deliveryNoteNumber
    }
    calculatedPlannedQuantity
    calculatedPackedQuantity
    goodsHolderMeasures {
      grossVolume {
        measureValue
        measureUOM
      }
      grossWeight {
        measureUOM
        measureValue
      }
    }
  }
  getTrackAndTraceByGoodsHolder(goodsHolderNumber: $goodsHolderNumber) {
    messageControl {
      sourceSystemName
    }
    shipmentTrackTrace {
      deliveryAppointmentTimestamp
      estimatedDeliveryTimestamp
      event {
        eventTimestamp
        lifecycleStatusCode
        lifecycleStatusDescription
        reasonCode
        reasonCodeDescription
        carrierStatusCode
        carrierStatusDescription
        intermediateStatusCode
        intermediateStatusDescription
        isException
      }
      vendor {
        shipViaCode
        standardCarrierAlphaCode
      }
    }
  }
}
    `;

/**
 * __useGetGoodsHolderQuery__
 *
 * To run a query within a React component, call `useGetGoodsHolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoodsHolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoodsHolderQuery({
 *   variables: {
 *      goodsHolderNumber: // value for 'goodsHolderNumber'
 *   },
 * });
 */
export function useGetGoodsHolderQuery(baseOptions: Apollo.QueryHookOptions<GetGoodsHolderQuery, GetGoodsHolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoodsHolderQuery, GetGoodsHolderQueryVariables>(GetGoodsHolderDocument, options);
      }
export function useGetGoodsHolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoodsHolderQuery, GetGoodsHolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoodsHolderQuery, GetGoodsHolderQueryVariables>(GetGoodsHolderDocument, options);
        }
export type GetGoodsHolderQueryHookResult = ReturnType<typeof useGetGoodsHolderQuery>;
export type GetGoodsHolderLazyQueryHookResult = ReturnType<typeof useGetGoodsHolderLazyQuery>;
export type GetGoodsHolderQueryResult = Apollo.QueryResult<GetGoodsHolderQuery, GetGoodsHolderQueryVariables>;
export const GetGoodsHoldersDocument = gql`
    query getGoodsHolders($packlistNumber: String!, $from: Int = 0, $size: Int = 50) {
  getGoodsHoldersByPacklist(
    packlistNumber: $packlistNumber
    from: $from
    size: $size
  ) {
    goodsHolderNumber
    goodsHolderTrackingNumber
    goodsHolderTypeCode
    goodsHolderStatusCode
    calculatedGoodsHolderStatusCode
    calculatedPlannedQuantity
    calculatedPackedQuantity
    nikeSalesOrderTypeCode
    purchaseOrderNumber
    actualDeliveryDate
    transportHolder {
      transportHolderNumber
      proNumber
      directDropIndicator
      cmrTimestamp
      vendorAccessNumber
    }
    goodsHolderMeasures {
      grossWeight {
        measureUOM
        measureValue
      }
      grossVolume {
        measureUOM
        measureValue
      }
      height {
        measureUOM
        measureValue
      }
      length {
        measureUOM
        measureValue
      }
      width {
        measureUOM
        measureValue
      }
    }
    ttExceptions {
      code
      description
    }
  }
}
    `;

/**
 * __useGetGoodsHoldersQuery__
 *
 * To run a query within a React component, call `useGetGoodsHoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoodsHoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoodsHoldersQuery({
 *   variables: {
 *      packlistNumber: // value for 'packlistNumber'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetGoodsHoldersQuery(baseOptions: Apollo.QueryHookOptions<GetGoodsHoldersQuery, GetGoodsHoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoodsHoldersQuery, GetGoodsHoldersQueryVariables>(GetGoodsHoldersDocument, options);
      }
export function useGetGoodsHoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoodsHoldersQuery, GetGoodsHoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoodsHoldersQuery, GetGoodsHoldersQueryVariables>(GetGoodsHoldersDocument, options);
        }
export type GetGoodsHoldersQueryHookResult = ReturnType<typeof useGetGoodsHoldersQuery>;
export type GetGoodsHoldersLazyQueryHookResult = ReturnType<typeof useGetGoodsHoldersLazyQuery>;
export type GetGoodsHoldersQueryResult = Apollo.QueryResult<GetGoodsHoldersQuery, GetGoodsHoldersQueryVariables>;
export const GetShipmentMaterialsDocument = gql`
    query getShipmentMaterials($packlistNumber: String!) {
  getShipmentMaterials(packlistNumber: $packlistNumber) {
    productCode
    sizeCode
    quantity
    divisionCode
    deliveryNoteNumber
    purchaseOrderNumber
    salesOrderNumber
    customerPurchaseOrderNumber
    upc
  }
}
    `;

/**
 * __useGetShipmentMaterialsQuery__
 *
 * To run a query within a React component, call `useGetShipmentMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentMaterialsQuery({
 *   variables: {
 *      packlistNumber: // value for 'packlistNumber'
 *   },
 * });
 */
export function useGetShipmentMaterialsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentMaterialsQuery, GetShipmentMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentMaterialsQuery, GetShipmentMaterialsQueryVariables>(GetShipmentMaterialsDocument, options);
      }
export function useGetShipmentMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentMaterialsQuery, GetShipmentMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentMaterialsQuery, GetShipmentMaterialsQueryVariables>(GetShipmentMaterialsDocument, options);
        }
export type GetShipmentMaterialsQueryHookResult = ReturnType<typeof useGetShipmentMaterialsQuery>;
export type GetShipmentMaterialsLazyQueryHookResult = ReturnType<typeof useGetShipmentMaterialsLazyQuery>;
export type GetShipmentMaterialsQueryResult = Apollo.QueryResult<GetShipmentMaterialsQuery, GetShipmentMaterialsQueryVariables>;
export const SearchGoodsHoldersDocument = gql`
    query searchGoodsHolders($packlistNumber: String!, $goodsHolderNumbers: [String!], $proNumbers: [String!], $vendorAccessNumbers: [String!], $calculatedGoodsHolderStatusCodes: [String!], $from: Int, $size: Int) {
  searchGoodsHolders(
    packlistNumber: $packlistNumber
    goodsHolderNumbers: $goodsHolderNumbers
    proNumbers: $proNumbers
    vendorAccessNumbers: $vendorAccessNumbers
    calculatedGoodsHolderStatusCodes: $calculatedGoodsHolderStatusCodes
    from: $from
    size: $size
  ) {
    goodsHolderNumber
    goodsHolderTrackingNumber
    goodsHolderTypeCode
    goodsHolderStatusCode
    calculatedGoodsHolderStatusCode
    calculatedPlannedQuantity
    calculatedPackedQuantity
    nikeSalesOrderTypeCode
    purchaseOrderNumber
    actualDeliveryDate
    transportHolder {
      transportHolderNumber
      proNumber
      directDropIndicator
      cmrTimestamp
      vendorAccessNumber
    }
    goodsHolderMeasures {
      grossWeight {
        measureUOM
        measureValue
      }
      grossVolume {
        measureUOM
        measureValue
      }
    }
    ttExceptions {
      code
      description
    }
  }
}
    `;

/**
 * __useSearchGoodsHoldersQuery__
 *
 * To run a query within a React component, call `useSearchGoodsHoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGoodsHoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGoodsHoldersQuery({
 *   variables: {
 *      packlistNumber: // value for 'packlistNumber'
 *      goodsHolderNumbers: // value for 'goodsHolderNumbers'
 *      proNumbers: // value for 'proNumbers'
 *      vendorAccessNumbers: // value for 'vendorAccessNumbers'
 *      calculatedGoodsHolderStatusCodes: // value for 'calculatedGoodsHolderStatusCodes'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchGoodsHoldersQuery(baseOptions: Apollo.QueryHookOptions<SearchGoodsHoldersQuery, SearchGoodsHoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchGoodsHoldersQuery, SearchGoodsHoldersQueryVariables>(SearchGoodsHoldersDocument, options);
      }
export function useSearchGoodsHoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchGoodsHoldersQuery, SearchGoodsHoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchGoodsHoldersQuery, SearchGoodsHoldersQueryVariables>(SearchGoodsHoldersDocument, options);
        }
export type SearchGoodsHoldersQueryHookResult = ReturnType<typeof useSearchGoodsHoldersQuery>;
export type SearchGoodsHoldersLazyQueryHookResult = ReturnType<typeof useSearchGoodsHoldersLazyQuery>;
export type SearchGoodsHoldersQueryResult = Apollo.QueryResult<SearchGoodsHoldersQuery, SearchGoodsHoldersQueryVariables>;
export const SearchDeliveryNotesDocument = gql`
    query searchDeliveryNotes($search: String, $salesOrderNumbers: [String!], $deliveryNoteNumbers: [String!], $shipToCodes: [String!], $shippingPointCodes: [String!], $from: Int, $size: Int) {
  searchDeliveryNotes(
    search: $search
    salesOrderNumbers: $salesOrderNumbers
    deliveryNoteNumbers: $deliveryNoteNumbers
    shipToCodes: $shipToCodes
    shippingPointCodes: $shippingPointCodes
    from: $from
    size: $size
  ) {
    deliveryNote {
      fulfillmentRequestHeader {
        exportIndicator
        fulfillmentRequestDate {
          estimatedDeliveryTimestamp
          deliveryPlanScheduledDeliveryDate
        }
        fulfillmentRequestItem {
          salesUnitQuantity
        }
        fulfillmentRequestNumber
        fulfillmentRequestParty {
          fulfillmentRequestLocationAddress {
            transportationZone
          }
          partyIdentifier
          partyName1
          partyTypeCode
        }
        fulfillmentRequestReference {
          referenceNumberTypeCode
          referenceNumberValue
        }
        orderType
        shipToAddressOverrideIndicator
        shippingPointCode
      }
    }
    shipments {
      packlistNumber
      proNumbers
      shippingPointCode
      vendorAccessNumbers
      transportHolderNumbers
      calculatedCmrShipmentCount
      calculatedCmrGoodsHolderCount
      plannedShipmentReadyTimestamp
      transportHolderLicensePlateNumbers
      transportHolderSealNumbers
      transportHolderTypeSizeCodes
      transportHolderGrossVolume {
        measureValue
        measureUOM
      }
      deliveries {
        salesOrderNumber
      }
    }
  }
}
    `;

/**
 * __useSearchDeliveryNotesQuery__
 *
 * To run a query within a React component, call `useSearchDeliveryNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDeliveryNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDeliveryNotesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      salesOrderNumbers: // value for 'salesOrderNumbers'
 *      deliveryNoteNumbers: // value for 'deliveryNoteNumbers'
 *      shipToCodes: // value for 'shipToCodes'
 *      shippingPointCodes: // value for 'shippingPointCodes'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchDeliveryNotesQuery(baseOptions?: Apollo.QueryHookOptions<SearchDeliveryNotesQuery, SearchDeliveryNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDeliveryNotesQuery, SearchDeliveryNotesQueryVariables>(SearchDeliveryNotesDocument, options);
      }
export function useSearchDeliveryNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDeliveryNotesQuery, SearchDeliveryNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDeliveryNotesQuery, SearchDeliveryNotesQueryVariables>(SearchDeliveryNotesDocument, options);
        }
export type SearchDeliveryNotesQueryHookResult = ReturnType<typeof useSearchDeliveryNotesQuery>;
export type SearchDeliveryNotesLazyQueryHookResult = ReturnType<typeof useSearchDeliveryNotesLazyQuery>;
export type SearchDeliveryNotesQueryResult = Apollo.QueryResult<SearchDeliveryNotesQuery, SearchDeliveryNotesQueryVariables>;
export const SearchDeliveryNotesForExportDocument = gql`
    query searchDeliveryNotesForExport($search: String, $salesOrderNumbers: [String!], $deliveryNoteNumbers: [String!], $shipToCodes: [String!], $from: Int, $size: Int) {
  searchDeliveryNotes(
    search: $search
    salesOrderNumbers: $salesOrderNumbers
    deliveryNoteNumbers: $deliveryNoteNumbers
    shipToCodes: $shipToCodes
    from: $from
    size: $size
  ) {
    deliveryNote {
      fulfillmentRequestHeader {
        exportIndicator
        fulfillmentRequestDate {
          plannedGoodsIssueTimestamp
          deliveryPlanScheduledDeliveryDate
        }
        fulfillmentRequestItem {
          salesUnitQuantity
        }
        fulfillmentRequestInstruction {
          instruction1Text
          vasIndicator
          instructionCode
        }
        fulfillmentRequestNumber
        fulfillmentRequestParty {
          fulfillmentRequestLocationAddress {
            countryCode
            transportationZone
          }
          partyIdentifier
          partyName1
          partyTypeCode
        }
        fulfillmentRequestReference {
          referenceNumberTypeCode
          referenceNumberValue
        }
        orderType
        shipToAddressOverrideIndicator
        shippingPointCode
      }
    }
    shipments {
      packlistNumber
      proNumbers
      shippingPointCode
      deliveries {
        salesOrderNumber
      }
    }
  }
}
    `;

/**
 * __useSearchDeliveryNotesForExportQuery__
 *
 * To run a query within a React component, call `useSearchDeliveryNotesForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDeliveryNotesForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDeliveryNotesForExportQuery({
 *   variables: {
 *      search: // value for 'search'
 *      salesOrderNumbers: // value for 'salesOrderNumbers'
 *      deliveryNoteNumbers: // value for 'deliveryNoteNumbers'
 *      shipToCodes: // value for 'shipToCodes'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchDeliveryNotesForExportQuery(baseOptions?: Apollo.QueryHookOptions<SearchDeliveryNotesForExportQuery, SearchDeliveryNotesForExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDeliveryNotesForExportQuery, SearchDeliveryNotesForExportQueryVariables>(SearchDeliveryNotesForExportDocument, options);
      }
export function useSearchDeliveryNotesForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDeliveryNotesForExportQuery, SearchDeliveryNotesForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDeliveryNotesForExportQuery, SearchDeliveryNotesForExportQueryVariables>(SearchDeliveryNotesForExportDocument, options);
        }
export type SearchDeliveryNotesForExportQueryHookResult = ReturnType<typeof useSearchDeliveryNotesForExportQuery>;
export type SearchDeliveryNotesForExportLazyQueryHookResult = ReturnType<typeof useSearchDeliveryNotesForExportLazyQuery>;
export type SearchDeliveryNotesForExportQueryResult = Apollo.QueryResult<SearchDeliveryNotesForExportQuery, SearchDeliveryNotesForExportQueryVariables>;
export const SearchDeliveryNotesWithCustomerDetailsDocument = gql`
    query searchDeliveryNotesWithCustomerDetails($search: String, $salesOrderNumbers: [String!], $deliveryNoteNumbers: [String!], $shipToCodes: [String!], $shippingPointCodes: [String!], $from: Int, $size: Int) {
  searchDeliveryNotes(
    search: $search
    salesOrderNumbers: $salesOrderNumbers
    deliveryNoteNumbers: $deliveryNoteNumbers
    shipToCodes: $shipToCodes
    shippingPointCodes: $shippingPointCodes
    from: $from
    size: $size
  ) {
    deliveryNote {
      fulfillmentRequestHeader {
        exportIndicator
        fulfillmentRequestDate {
          estimatedDeliveryTimestamp
          deliveryPlanScheduledDeliveryDate
        }
        fulfillmentRequestItem {
          salesUnitQuantity
        }
        fulfillmentRequestNumber
        fulfillmentRequestParty {
          partyName1
          partyName2
          partyIdentifier
          partyTypeCode
          fulfillmentRequestLocationAddress {
            addressLine1Text
            addressLine2Text
            addressLine3Text
            addressLine4Text
            addressLine5Text
            cityName
            countryCode
            languageCode
            postalCode
            stateProvinceCode
            transportationZone
          }
          fulfillmentRequestContact {
            dayPhoneNumber
            emailAddressText
          }
        }
        fulfillmentRequestReference {
          referenceNumberTypeCode
          referenceNumberValue
        }
        orderType
        shipToAddressOverrideIndicator
        shippingPointCode
      }
    }
    shipments {
      packlistNumber
      proNumbers
      shippingPointCode
      vendorAccessNumbers
      transportHolderNumbers
      calculatedCmrShipmentCount
      calculatedCmrGoodsHolderCount
      plannedShipmentReadyTimestamp
      transportHolderLicensePlateNumbers
      transportHolderSealNumbers
      transportHolderTypeSizeCodes
      transportHolderGrossVolume {
        measureValue
        measureUOM
      }
      deliveries {
        salesOrderNumber
      }
    }
  }
}
    `;

/**
 * __useSearchDeliveryNotesWithCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useSearchDeliveryNotesWithCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDeliveryNotesWithCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDeliveryNotesWithCustomerDetailsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      salesOrderNumbers: // value for 'salesOrderNumbers'
 *      deliveryNoteNumbers: // value for 'deliveryNoteNumbers'
 *      shipToCodes: // value for 'shipToCodes'
 *      shippingPointCodes: // value for 'shippingPointCodes'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchDeliveryNotesWithCustomerDetailsQuery(baseOptions?: Apollo.QueryHookOptions<SearchDeliveryNotesWithCustomerDetailsQuery, SearchDeliveryNotesWithCustomerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDeliveryNotesWithCustomerDetailsQuery, SearchDeliveryNotesWithCustomerDetailsQueryVariables>(SearchDeliveryNotesWithCustomerDetailsDocument, options);
      }
export function useSearchDeliveryNotesWithCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDeliveryNotesWithCustomerDetailsQuery, SearchDeliveryNotesWithCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDeliveryNotesWithCustomerDetailsQuery, SearchDeliveryNotesWithCustomerDetailsQueryVariables>(SearchDeliveryNotesWithCustomerDetailsDocument, options);
        }
export type SearchDeliveryNotesWithCustomerDetailsQueryHookResult = ReturnType<typeof useSearchDeliveryNotesWithCustomerDetailsQuery>;
export type SearchDeliveryNotesWithCustomerDetailsLazyQueryHookResult = ReturnType<typeof useSearchDeliveryNotesWithCustomerDetailsLazyQuery>;
export type SearchDeliveryNotesWithCustomerDetailsQueryResult = Apollo.QueryResult<SearchDeliveryNotesWithCustomerDetailsQuery, SearchDeliveryNotesWithCustomerDetailsQueryVariables>;
export const GetDeliveryNoteDocument = gql`
    query getDeliveryNote($deliveryNoteNumber: String!) {
  getDeliveryNote(deliveryNoteNumber: $deliveryNoteNumber) {
    fulfillmentRequestHeader {
      fulfillmentRequestParty {
        partyName1
        partyName2
        partyIdentifier
        fulfillmentRequestLocationAddress {
          addressLine1Text
          addressLine2Text
          addressLine3Text
          addressLine4Text
          addressLine5Text
          cityName
          countryCode
          postalCode
          languageCode
          stateProvinceCode
          transportationZone
        }
        fulfillmentRequestContact {
          dayPhoneNumber
          emailAddressText
        }
      }
    }
  }
}
    `;

/**
 * __useGetDeliveryNoteQuery__
 *
 * To run a query within a React component, call `useGetDeliveryNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryNoteQuery({
 *   variables: {
 *      deliveryNoteNumber: // value for 'deliveryNoteNumber'
 *   },
 * });
 */
export function useGetDeliveryNoteQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryNoteQuery, GetDeliveryNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryNoteQuery, GetDeliveryNoteQueryVariables>(GetDeliveryNoteDocument, options);
      }
export function useGetDeliveryNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryNoteQuery, GetDeliveryNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryNoteQuery, GetDeliveryNoteQueryVariables>(GetDeliveryNoteDocument, options);
        }
export type GetDeliveryNoteQueryHookResult = ReturnType<typeof useGetDeliveryNoteQuery>;
export type GetDeliveryNoteLazyQueryHookResult = ReturnType<typeof useGetDeliveryNoteLazyQuery>;
export type GetDeliveryNoteQueryResult = Apollo.QueryResult<GetDeliveryNoteQuery, GetDeliveryNoteQueryVariables>;
export const GetCustomerDetailsForPacklistDocument = gql`
    query getCustomerDetailsForPacklist($packlistNumber: String!) {
  getCustomerDetailsForPacklist(packlistNumber: $packlistNumber) {
    packlistNumber
    shipmentShipToAddress {
      shipToCode
      shipToName
      shipToName2
      countryCode
      addressLine1Text
      addressLine2Text
      addressLine3Text
      addressLine4Text
      cityName
      zipCode
      provinceStateRegionCode
      emailAddressText
      phoneNumber
      languageCode
      countyName
      shipToDropoffPointIdentifier
      thirdPartyDepartmentLocationText
    }
  }
}
    `;

/**
 * __useGetCustomerDetailsForPacklistQuery__
 *
 * To run a query within a React component, call `useGetCustomerDetailsForPacklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDetailsForPacklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDetailsForPacklistQuery({
 *   variables: {
 *      packlistNumber: // value for 'packlistNumber'
 *   },
 * });
 */
export function useGetCustomerDetailsForPacklistQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerDetailsForPacklistQuery, GetCustomerDetailsForPacklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerDetailsForPacklistQuery, GetCustomerDetailsForPacklistQueryVariables>(GetCustomerDetailsForPacklistDocument, options);
      }
export function useGetCustomerDetailsForPacklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerDetailsForPacklistQuery, GetCustomerDetailsForPacklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerDetailsForPacklistQuery, GetCustomerDetailsForPacklistQueryVariables>(GetCustomerDetailsForPacklistDocument, options);
        }
export type GetCustomerDetailsForPacklistQueryHookResult = ReturnType<typeof useGetCustomerDetailsForPacklistQuery>;
export type GetCustomerDetailsForPacklistLazyQueryHookResult = ReturnType<typeof useGetCustomerDetailsForPacklistLazyQuery>;
export type GetCustomerDetailsForPacklistQueryResult = Apollo.QueryResult<GetCustomerDetailsForPacklistQuery, GetCustomerDetailsForPacklistQueryVariables>;
export const GetShipmentDocument = gql`
    query getShipment($packlistNumber: String!) {
  getShipment(packlistNumber: $packlistNumber) {
    packlistNumber
    idReferenceNumber
    iDPIndicator
    iDPPlannedTimestamp
    deliveryInstructionText
    deliveries {
      deliveryNoteNumber
      customerPurchaseOrderNumber
      nikeSalesOrderTypeCode
      purchaseOrderNumber
      salesOrderNumber
      fulfillmentRequestDate {
        cancelByDt
        estimatedDeliveryTimestamp
      }
    }
    estimatedDeliveryDate
    plannedShipmentReadyTimestamp
    actualShipmentPlannedDate
    actualShipmentReadyTimestamp
    plannedShipmentCloseFromTimestamp
    plannedDeliveryFromTimestamp
    plannedDeliveryToTimestamp
    actualShipmentCloseTimestamp
    actualDeliveryDate
    actualShippedTimestamp
    plannedGoodsHolderCount
    calculatedPlannedQuantity
    calculatedGoodsHolderCount
    calculatedPackedQuantity
    calculatedEstimatedDeliveryTimestamp
    calculatedGrossVolume {
      measureValue
      measureUOM
    }
    calculatedGrossWeight {
      measureValue
      measureUOM
    }
    eddCalculation {
      transitDays
    }
    shipmentCancelTimestamp
    xDockFlag
    proNumbers
    vendorAccessNumbers
    transportHolderNumbers
    calculatedCmrShipmentCount
    calculatedCmrGoodsHolderCount
    transportHolderLicensePlateNumbers
    transportHolderSealNumbers
    transportHolderTypeSizeCodes
    transportHolderIdReferenceNumbers
    transportHolderGrossVolume {
      measureValue
      measureUOM
    }
    shipmentShipToAddress {
      shipToCode
      shipToName
      shipToName2
      countryCode
      addressOverrideIndicator
    }
    shipmentStatusCode
    calculatedShipmentStatusCode
    shipmentVendors {
      hubCode
      serviceLevelCode
      vendorCode
      vendorName
      vendorTypeCode
    }
    shippingPointCode
    rebooking {
      rebookingType
      iDPPlannedTimestamp
      lastRebookingTimestamp
      plannedDeliveryFromTimestamp
      plannedDeliveryToTimestamp
    }
    exportIndicator
    ttExceptions {
      code
      description
    }
    event_sources {
      s3Key
      processedTimestamp
    }
  }
}
    `;

/**
 * __useGetShipmentQuery__
 *
 * To run a query within a React component, call `useGetShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentQuery({
 *   variables: {
 *      packlistNumber: // value for 'packlistNumber'
 *   },
 * });
 */
export function useGetShipmentQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
      }
export function useGetShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentQuery, GetShipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, options);
        }
export type GetShipmentQueryHookResult = ReturnType<typeof useGetShipmentQuery>;
export type GetShipmentLazyQueryHookResult = ReturnType<typeof useGetShipmentLazyQuery>;
export type GetShipmentQueryResult = Apollo.QueryResult<GetShipmentQuery, GetShipmentQueryVariables>;
export const SearchShipmentsDocument = gql`
    query searchShipments($search: String, $packlistNumbers: [String!], $salesOrderNumbers: [String!], $deliveryNoteNumbers: [String!], $goodsHolderNumbers: [String!], $proNumbers: [String!], $vendorAccessNumbers: [String!], $transportHolderNumbers: [String!], $calculatedShipmentStatusCodes: [String!], $carrierHubs: [String!], $shipToCodes: [String!], $shipToNames: [String!], $shipToCountryCodes: [String!], $shippingPointCodes: [String!], $orderTypeCodes: [String!], $actualShippedTimestampFrom: [String!], $actualShippedTimestampTo: [String!], $actualDeliveryDateFrom: [String!], $actualDeliveryDateTo: [String!], $hasTTExceptions: [String!], $transportHolderLicensePlateNumbers: [String!], $transportHolderIdReferenceNumbers: [String!], $from: Int, $size: Int) {
  searchShipments(
    search: $search
    packlistNumbers: $packlistNumbers
    salesOrderNumbers: $salesOrderNumbers
    deliveryNoteNumbers: $deliveryNoteNumbers
    goodsHolderNumbers: $goodsHolderNumbers
    proNumbers: $proNumbers
    vendorAccessNumbers: $vendorAccessNumbers
    transportHolderNumbers: $transportHolderNumbers
    calculatedShipmentStatusCodes: $calculatedShipmentStatusCodes
    carrierHubs: $carrierHubs
    shipToCodes: $shipToCodes
    shipToNames: $shipToNames
    shipToCountryCodes: $shipToCountryCodes
    shippingPointCodes: $shippingPointCodes
    orderTypeCodes: $orderTypeCodes
    actualShippedTimestampFrom: $actualShippedTimestampFrom
    actualShippedTimestampTo: $actualShippedTimestampTo
    actualDeliveryDateFrom: $actualDeliveryDateFrom
    actualDeliveryDateTo: $actualDeliveryDateTo
    hasTTExceptions: $hasTTExceptions
    transportHolderLicensePlateNumbers: $transportHolderLicensePlateNumbers
    transportHolderIdReferenceNumbers: $transportHolderIdReferenceNumbers
    from: $from
    size: $size
  ) {
    packlistNumber
    proNumbers
    vendorAccessNumbers
    transportHolderNumbers
    xDockFlag
    calculatedCmrShipmentCount
    calculatedCmrGoodsHolderCount
    plannedShipmentReadyTimestamp
    transportHolderLicensePlateNumbers
    transportHolderSealNumbers
    transportHolderTypeSizeCodes
    transportHolderIdReferenceNumbers
    transportHolderGrossVolume {
      measureValue
      measureUOM
    }
    shipmentShipToAddress {
      shipToCode
      shipToName
    }
    shippingPointCode
    deliveries {
      deliveryNoteNumber
      salesOrderNumber
    }
    eddCalculation {
      transitDays
    }
    plannedGoodsHolderCount
    calculatedGoodsHolderCount
    calculatedPlannedQuantity
    calculatedPackedQuantity
    calculatedShipmentStatusCode
    estimatedDeliveryDate
    calculatedGrossVolume {
      measureValue
      measureUOM
    }
    calculatedGrossWeight {
      measureValue
      measureUOM
    }
    shipmentVendors {
      hubCode
      serviceLevelCode
      vendorCode
      vendorName
      vendorTypeCode
    }
    plannedDeliveryFromTimestamp
    plannedDeliveryToTimestamp
    iDPIndicator
    iDPPlannedTimestamp
    calculatedEstimatedDeliveryTimestamp
    actualShippedTimestamp
    actualDeliveryDate
    shipmentCancelTimestamp
    updatedByIdentifier
    shipmentTexts {
      textTypeCode
      textIdentifier
      textDescription
    }
    ttExceptions {
      code
      description
    }
    rebooking {
      rebookingType
      iDPPlannedTimestamp
      lastRebookingTimestamp
      plannedDeliveryFromTimestamp
      plannedDeliveryToTimestamp
    }
  }
}
    `;

/**
 * __useSearchShipmentsQuery__
 *
 * To run a query within a React component, call `useSearchShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchShipmentsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      packlistNumbers: // value for 'packlistNumbers'
 *      salesOrderNumbers: // value for 'salesOrderNumbers'
 *      deliveryNoteNumbers: // value for 'deliveryNoteNumbers'
 *      goodsHolderNumbers: // value for 'goodsHolderNumbers'
 *      proNumbers: // value for 'proNumbers'
 *      vendorAccessNumbers: // value for 'vendorAccessNumbers'
 *      transportHolderNumbers: // value for 'transportHolderNumbers'
 *      calculatedShipmentStatusCodes: // value for 'calculatedShipmentStatusCodes'
 *      carrierHubs: // value for 'carrierHubs'
 *      shipToCodes: // value for 'shipToCodes'
 *      shipToNames: // value for 'shipToNames'
 *      shipToCountryCodes: // value for 'shipToCountryCodes'
 *      shippingPointCodes: // value for 'shippingPointCodes'
 *      orderTypeCodes: // value for 'orderTypeCodes'
 *      actualShippedTimestampFrom: // value for 'actualShippedTimestampFrom'
 *      actualShippedTimestampTo: // value for 'actualShippedTimestampTo'
 *      actualDeliveryDateFrom: // value for 'actualDeliveryDateFrom'
 *      actualDeliveryDateTo: // value for 'actualDeliveryDateTo'
 *      hasTTExceptions: // value for 'hasTTExceptions'
 *      transportHolderLicensePlateNumbers: // value for 'transportHolderLicensePlateNumbers'
 *      transportHolderIdReferenceNumbers: // value for 'transportHolderIdReferenceNumbers'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<SearchShipmentsQuery, SearchShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchShipmentsQuery, SearchShipmentsQueryVariables>(SearchShipmentsDocument, options);
      }
export function useSearchShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchShipmentsQuery, SearchShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchShipmentsQuery, SearchShipmentsQueryVariables>(SearchShipmentsDocument, options);
        }
export type SearchShipmentsQueryHookResult = ReturnType<typeof useSearchShipmentsQuery>;
export type SearchShipmentsLazyQueryHookResult = ReturnType<typeof useSearchShipmentsLazyQuery>;
export type SearchShipmentsQueryResult = Apollo.QueryResult<SearchShipmentsQuery, SearchShipmentsQueryVariables>;
export const SearchShipmentsForExportDocument = gql`
    query searchShipmentsForExport($search: String, $packlistNumbers: [String!], $salesOrderNumbers: [String!], $deliveryNoteNumbers: [String!], $goodsHolderNumbers: [String!], $proNumbers: [String!], $vendorAccessNumbers: [String!], $transportHolderNumbers: [String!], $calculatedShipmentStatusCodes: [String!], $carrierHubs: [String!], $shipToCodes: [String!], $shipToNames: [String!], $shipToCountryCodes: [String!], $shippingPointCodes: [String!], $orderTypeCodes: [String!], $actualShippedTimestampFrom: [String!], $actualShippedTimestampTo: [String!], $actualDeliveryDateFrom: [String!], $actualDeliveryDateTo: [String!], $hasTTExceptions: [String!], $transportHolderLicensePlateNumbers: [String!], $transportHolderIdReferenceNumbers: [String!], $from: Int, $size: Int) {
  searchShipments(
    search: $search
    packlistNumbers: $packlistNumbers
    salesOrderNumbers: $salesOrderNumbers
    deliveryNoteNumbers: $deliveryNoteNumbers
    goodsHolderNumbers: $goodsHolderNumbers
    proNumbers: $proNumbers
    vendorAccessNumbers: $vendorAccessNumbers
    transportHolderNumbers: $transportHolderNumbers
    calculatedShipmentStatusCodes: $calculatedShipmentStatusCodes
    carrierHubs: $carrierHubs
    shipToCodes: $shipToCodes
    shipToNames: $shipToNames
    shipToCountryCodes: $shipToCountryCodes
    shippingPointCodes: $shippingPointCodes
    orderTypeCodes: $orderTypeCodes
    actualShippedTimestampFrom: $actualShippedTimestampFrom
    actualShippedTimestampTo: $actualShippedTimestampTo
    actualDeliveryDateFrom: $actualDeliveryDateFrom
    actualDeliveryDateTo: $actualDeliveryDateTo
    hasTTExceptions: $hasTTExceptions
    transportHolderLicensePlateNumbers: $transportHolderLicensePlateNumbers
    transportHolderIdReferenceNumbers: $transportHolderIdReferenceNumbers
    from: $from
    size: $size
  ) {
    iDPIndicator
    iDPPlannedTimestamp
    packlistNumber
    proNumbers
    vendorAccessNumbers
    transportHolderNumbers
    transportHolderLicensePlateNumbers
    transportHolderSealNumbers
    transportHolderIdReferenceNumbers
    exportIndicator
    xDockFlag
    shipmentShipToAddress {
      shipToCode
      shipToName
      countryCode
      addressOverrideIndicator
    }
    shippingPointCode
    deliveries {
      deliveryNoteNumber
      salesOrderNumber
      purchaseOrderNumber
      nikeSalesOrderTypeCode
    }
    plannedGoodsHolderCount
    calculatedGoodsHolderCount
    calculatedPlannedQuantity
    calculatedPackedQuantity
    calculatedShipmentStatusCode
    deliveryInstructionText
    estimatedDeliveryDate
    actualDeliveryDate
    actualShippedTimestamp
    actualShipmentPlannedDate
    iDPPlannedTimestamp
    plannedDeliveryFromTimestamp
    plannedDeliveryToTimestamp
    plannedShipmentReadyTimestamp
    calculatedEstimatedDeliveryTimestamp
    shipmentCancelTimestamp
    updatedByIdentifier
    shipmentTexts {
      textTypeCode
      textIdentifier
      textDescription
    }
    calculatedGrossVolume {
      measureValue
      measureUOM
    }
    calculatedGrossWeight {
      measureValue
      measureUOM
    }
    eddCalculation {
      transitDays
    }
    shipmentVendors {
      hubCode
      serviceLevelCode
      vendorCode
      vendorName
      vendorTypeCode
    }
    actualDeliveryDate
    ttExceptions {
      code
      description
    }
    rebooking {
      rebookingType
      iDPPlannedTimestamp
      plannedDeliveryFromTimestamp
      plannedDeliveryToTimestamp
    }
  }
}
    `;

/**
 * __useSearchShipmentsForExportQuery__
 *
 * To run a query within a React component, call `useSearchShipmentsForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchShipmentsForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchShipmentsForExportQuery({
 *   variables: {
 *      search: // value for 'search'
 *      packlistNumbers: // value for 'packlistNumbers'
 *      salesOrderNumbers: // value for 'salesOrderNumbers'
 *      deliveryNoteNumbers: // value for 'deliveryNoteNumbers'
 *      goodsHolderNumbers: // value for 'goodsHolderNumbers'
 *      proNumbers: // value for 'proNumbers'
 *      vendorAccessNumbers: // value for 'vendorAccessNumbers'
 *      transportHolderNumbers: // value for 'transportHolderNumbers'
 *      calculatedShipmentStatusCodes: // value for 'calculatedShipmentStatusCodes'
 *      carrierHubs: // value for 'carrierHubs'
 *      shipToCodes: // value for 'shipToCodes'
 *      shipToNames: // value for 'shipToNames'
 *      shipToCountryCodes: // value for 'shipToCountryCodes'
 *      shippingPointCodes: // value for 'shippingPointCodes'
 *      orderTypeCodes: // value for 'orderTypeCodes'
 *      actualShippedTimestampFrom: // value for 'actualShippedTimestampFrom'
 *      actualShippedTimestampTo: // value for 'actualShippedTimestampTo'
 *      actualDeliveryDateFrom: // value for 'actualDeliveryDateFrom'
 *      actualDeliveryDateTo: // value for 'actualDeliveryDateTo'
 *      hasTTExceptions: // value for 'hasTTExceptions'
 *      transportHolderLicensePlateNumbers: // value for 'transportHolderLicensePlateNumbers'
 *      transportHolderIdReferenceNumbers: // value for 'transportHolderIdReferenceNumbers'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchShipmentsForExportQuery(baseOptions?: Apollo.QueryHookOptions<SearchShipmentsForExportQuery, SearchShipmentsForExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchShipmentsForExportQuery, SearchShipmentsForExportQueryVariables>(SearchShipmentsForExportDocument, options);
      }
export function useSearchShipmentsForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchShipmentsForExportQuery, SearchShipmentsForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchShipmentsForExportQuery, SearchShipmentsForExportQueryVariables>(SearchShipmentsForExportDocument, options);
        }
export type SearchShipmentsForExportQueryHookResult = ReturnType<typeof useSearchShipmentsForExportQuery>;
export type SearchShipmentsForExportLazyQueryHookResult = ReturnType<typeof useSearchShipmentsForExportLazyQuery>;
export type SearchShipmentsForExportQueryResult = Apollo.QueryResult<SearchShipmentsForExportQuery, SearchShipmentsForExportQueryVariables>;
export const SearchShipmentsForExportWithCustomerDetailsDocument = gql`
    query searchShipmentsForExportWithCustomerDetails($search: String, $packlistNumbers: [String!], $salesOrderNumbers: [String!], $deliveryNoteNumbers: [String!], $goodsHolderNumbers: [String!], $proNumbers: [String!], $vendorAccessNumbers: [String!], $transportHolderNumbers: [String!], $calculatedShipmentStatusCodes: [String!], $carrierHubs: [String!], $shipToCodes: [String!], $shipToNames: [String!], $shipToCountryCodes: [String!], $shippingPointCodes: [String!], $orderTypeCodes: [String!], $actualShippedTimestampFrom: [String!], $actualShippedTimestampTo: [String!], $actualDeliveryDateFrom: [String!], $actualDeliveryDateTo: [String!], $hasTTExceptions: [String!], $transportHolderLicensePlateNumbers: [String!], $transportHolderIdReferenceNumbers: [String!], $from: Int, $size: Int) {
  searchShipments(
    search: $search
    packlistNumbers: $packlistNumbers
    salesOrderNumbers: $salesOrderNumbers
    deliveryNoteNumbers: $deliveryNoteNumbers
    goodsHolderNumbers: $goodsHolderNumbers
    proNumbers: $proNumbers
    vendorAccessNumbers: $vendorAccessNumbers
    transportHolderNumbers: $transportHolderNumbers
    calculatedShipmentStatusCodes: $calculatedShipmentStatusCodes
    carrierHubs: $carrierHubs
    shipToCodes: $shipToCodes
    shipToNames: $shipToNames
    shipToCountryCodes: $shipToCountryCodes
    shippingPointCodes: $shippingPointCodes
    orderTypeCodes: $orderTypeCodes
    actualShippedTimestampFrom: $actualShippedTimestampFrom
    actualShippedTimestampTo: $actualShippedTimestampTo
    actualDeliveryDateFrom: $actualDeliveryDateFrom
    actualDeliveryDateTo: $actualDeliveryDateTo
    hasTTExceptions: $hasTTExceptions
    transportHolderLicensePlateNumbers: $transportHolderLicensePlateNumbers
    transportHolderIdReferenceNumbers: $transportHolderIdReferenceNumbers
    from: $from
    size: $size
  ) {
    iDPIndicator
    iDPPlannedTimestamp
    packlistNumber
    proNumbers
    vendorAccessNumbers
    transportHolderNumbers
    transportHolderLicensePlateNumbers
    transportHolderSealNumbers
    transportHolderIdReferenceNumbers
    xDockFlag
    exportIndicator
    shipmentShipToAddress {
      shipToCode
      shipToName
      countryCode
      addressLine1Text
      addressLine2Text
      addressLine3Text
      cityName
      zipCode
      emailAddressText
      phoneNumber
      addressOverrideIndicator
    }
    shippingPointCode
    deliveries {
      deliveryNoteNumber
      salesOrderNumber
      purchaseOrderNumber
      nikeSalesOrderTypeCode
    }
    plannedGoodsHolderCount
    calculatedGoodsHolderCount
    calculatedPlannedQuantity
    calculatedPackedQuantity
    calculatedShipmentStatusCode
    deliveryInstructionText
    estimatedDeliveryDate
    actualDeliveryDate
    actualShippedTimestamp
    actualShipmentPlannedDate
    iDPPlannedTimestamp
    plannedDeliveryFromTimestamp
    plannedDeliveryToTimestamp
    plannedShipmentReadyTimestamp
    calculatedEstimatedDeliveryTimestamp
    shipmentCancelTimestamp
    updatedByIdentifier
    shipmentTexts {
      textTypeCode
      textIdentifier
      textDescription
    }
    calculatedGrossVolume {
      measureValue
      measureUOM
    }
    calculatedGrossWeight {
      measureValue
      measureUOM
    }
    eddCalculation {
      transitDays
    }
    shipmentVendors {
      hubCode
      serviceLevelCode
      vendorCode
      vendorName
      vendorTypeCode
    }
    actualDeliveryDate
    ttExceptions {
      code
      description
    }
    rebooking {
      rebookingType
      iDPPlannedTimestamp
      plannedDeliveryFromTimestamp
      plannedDeliveryToTimestamp
    }
  }
}
    `;

/**
 * __useSearchShipmentsForExportWithCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useSearchShipmentsForExportWithCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchShipmentsForExportWithCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchShipmentsForExportWithCustomerDetailsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      packlistNumbers: // value for 'packlistNumbers'
 *      salesOrderNumbers: // value for 'salesOrderNumbers'
 *      deliveryNoteNumbers: // value for 'deliveryNoteNumbers'
 *      goodsHolderNumbers: // value for 'goodsHolderNumbers'
 *      proNumbers: // value for 'proNumbers'
 *      vendorAccessNumbers: // value for 'vendorAccessNumbers'
 *      transportHolderNumbers: // value for 'transportHolderNumbers'
 *      calculatedShipmentStatusCodes: // value for 'calculatedShipmentStatusCodes'
 *      carrierHubs: // value for 'carrierHubs'
 *      shipToCodes: // value for 'shipToCodes'
 *      shipToNames: // value for 'shipToNames'
 *      shipToCountryCodes: // value for 'shipToCountryCodes'
 *      shippingPointCodes: // value for 'shippingPointCodes'
 *      orderTypeCodes: // value for 'orderTypeCodes'
 *      actualShippedTimestampFrom: // value for 'actualShippedTimestampFrom'
 *      actualShippedTimestampTo: // value for 'actualShippedTimestampTo'
 *      actualDeliveryDateFrom: // value for 'actualDeliveryDateFrom'
 *      actualDeliveryDateTo: // value for 'actualDeliveryDateTo'
 *      hasTTExceptions: // value for 'hasTTExceptions'
 *      transportHolderLicensePlateNumbers: // value for 'transportHolderLicensePlateNumbers'
 *      transportHolderIdReferenceNumbers: // value for 'transportHolderIdReferenceNumbers'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchShipmentsForExportWithCustomerDetailsQuery(baseOptions?: Apollo.QueryHookOptions<SearchShipmentsForExportWithCustomerDetailsQuery, SearchShipmentsForExportWithCustomerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchShipmentsForExportWithCustomerDetailsQuery, SearchShipmentsForExportWithCustomerDetailsQueryVariables>(SearchShipmentsForExportWithCustomerDetailsDocument, options);
      }
export function useSearchShipmentsForExportWithCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchShipmentsForExportWithCustomerDetailsQuery, SearchShipmentsForExportWithCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchShipmentsForExportWithCustomerDetailsQuery, SearchShipmentsForExportWithCustomerDetailsQueryVariables>(SearchShipmentsForExportWithCustomerDetailsDocument, options);
        }
export type SearchShipmentsForExportWithCustomerDetailsQueryHookResult = ReturnType<typeof useSearchShipmentsForExportWithCustomerDetailsQuery>;
export type SearchShipmentsForExportWithCustomerDetailsLazyQueryHookResult = ReturnType<typeof useSearchShipmentsForExportWithCustomerDetailsLazyQuery>;
export type SearchShipmentsForExportWithCustomerDetailsQueryResult = Apollo.QueryResult<SearchShipmentsForExportWithCustomerDetailsQuery, SearchShipmentsForExportWithCustomerDetailsQueryVariables>;
export const SearchShipmentsWithCustomerDetailsDocument = gql`
    query searchShipmentsWithCustomerDetails($search: String, $packlistNumbers: [String!], $salesOrderNumbers: [String!], $deliveryNoteNumbers: [String!], $goodsHolderNumbers: [String!], $proNumbers: [String!], $vendorAccessNumbers: [String!], $transportHolderNumbers: [String!], $calculatedShipmentStatusCodes: [String!], $carrierHubs: [String!], $shipToCodes: [String!], $shipToNames: [String!], $shipToCountryCodes: [String!], $shippingPointCodes: [String!], $orderTypeCodes: [String!], $actualShippedTimestampFrom: [String!], $actualShippedTimestampTo: [String!], $actualDeliveryDateFrom: [String!], $actualDeliveryDateTo: [String!], $hasTTExceptions: [String!], $transportHolderLicensePlateNumbers: [String!], $transportHolderIdReferenceNumbers: [String!], $from: Int, $size: Int) {
  searchShipments(
    search: $search
    packlistNumbers: $packlistNumbers
    salesOrderNumbers: $salesOrderNumbers
    deliveryNoteNumbers: $deliveryNoteNumbers
    goodsHolderNumbers: $goodsHolderNumbers
    proNumbers: $proNumbers
    vendorAccessNumbers: $vendorAccessNumbers
    transportHolderNumbers: $transportHolderNumbers
    calculatedShipmentStatusCodes: $calculatedShipmentStatusCodes
    carrierHubs: $carrierHubs
    shipToCodes: $shipToCodes
    shipToNames: $shipToNames
    shipToCountryCodes: $shipToCountryCodes
    shippingPointCodes: $shippingPointCodes
    orderTypeCodes: $orderTypeCodes
    actualShippedTimestampFrom: $actualShippedTimestampFrom
    actualShippedTimestampTo: $actualShippedTimestampTo
    actualDeliveryDateFrom: $actualDeliveryDateFrom
    actualDeliveryDateTo: $actualDeliveryDateTo
    hasTTExceptions: $hasTTExceptions
    transportHolderLicensePlateNumbers: $transportHolderLicensePlateNumbers
    transportHolderIdReferenceNumbers: $transportHolderIdReferenceNumbers
    from: $from
    size: $size
  ) {
    iDPIndicator
    iDPPlannedTimestamp
    packlistNumber
    proNumbers
    vendorAccessNumbers
    transportHolderNumbers
    calculatedCmrShipmentCount
    calculatedCmrGoodsHolderCount
    plannedShipmentReadyTimestamp
    transportHolderLicensePlateNumbers
    transportHolderSealNumbers
    transportHolderTypeSizeCodes
    transportHolderIdReferenceNumbers
    transportHolderGrossVolume {
      measureValue
      measureUOM
    }
    xDockFlag
    exportIndicator
    shipmentShipToAddress {
      shipToCode
      shipToName
      shipToName2
      countryCode
      addressLine1Text
      addressLine2Text
      addressLine3Text
      addressLine4Text
      cityName
      zipCode
      provinceStateRegionCode
      emailAddressText
      phoneNumber
      languageCode
      countyName
      shipToDropoffPointIdentifier
      thirdPartyDepartmentLocationText
    }
    shippingPointCode
    deliveries {
      deliveryNoteNumber
      salesOrderNumber
      purchaseOrderNumber
      nikeSalesOrderTypeCode
    }
    plannedGoodsHolderCount
    calculatedGoodsHolderCount
    calculatedPlannedQuantity
    calculatedPackedQuantity
    calculatedShipmentStatusCode
    deliveryInstructionText
    estimatedDeliveryDate
    actualDeliveryDate
    actualShippedTimestamp
    actualShipmentPlannedDate
    iDPPlannedTimestamp
    plannedDeliveryFromTimestamp
    plannedDeliveryToTimestamp
    plannedShipmentReadyTimestamp
    calculatedEstimatedDeliveryTimestamp
    shipmentCancelTimestamp
    updatedByIdentifier
    shipmentTexts {
      textTypeCode
      textIdentifier
      textDescription
    }
    calculatedGrossVolume {
      measureValue
      measureUOM
    }
    calculatedGrossWeight {
      measureValue
      measureUOM
    }
    eddCalculation {
      transitDays
    }
    shipmentVendors {
      hubCode
      serviceLevelCode
      vendorCode
      vendorName
      vendorTypeCode
    }
    actualShippedTimestamp
    actualDeliveryDate
    ttExceptions {
      code
      description
    }
    rebooking {
      rebookingType
      iDPPlannedTimestamp
      plannedDeliveryFromTimestamp
      plannedDeliveryToTimestamp
    }
  }
}
    `;

/**
 * __useSearchShipmentsWithCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useSearchShipmentsWithCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchShipmentsWithCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchShipmentsWithCustomerDetailsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      packlistNumbers: // value for 'packlistNumbers'
 *      salesOrderNumbers: // value for 'salesOrderNumbers'
 *      deliveryNoteNumbers: // value for 'deliveryNoteNumbers'
 *      goodsHolderNumbers: // value for 'goodsHolderNumbers'
 *      proNumbers: // value for 'proNumbers'
 *      vendorAccessNumbers: // value for 'vendorAccessNumbers'
 *      transportHolderNumbers: // value for 'transportHolderNumbers'
 *      calculatedShipmentStatusCodes: // value for 'calculatedShipmentStatusCodes'
 *      carrierHubs: // value for 'carrierHubs'
 *      shipToCodes: // value for 'shipToCodes'
 *      shipToNames: // value for 'shipToNames'
 *      shipToCountryCodes: // value for 'shipToCountryCodes'
 *      shippingPointCodes: // value for 'shippingPointCodes'
 *      orderTypeCodes: // value for 'orderTypeCodes'
 *      actualShippedTimestampFrom: // value for 'actualShippedTimestampFrom'
 *      actualShippedTimestampTo: // value for 'actualShippedTimestampTo'
 *      actualDeliveryDateFrom: // value for 'actualDeliveryDateFrom'
 *      actualDeliveryDateTo: // value for 'actualDeliveryDateTo'
 *      hasTTExceptions: // value for 'hasTTExceptions'
 *      transportHolderLicensePlateNumbers: // value for 'transportHolderLicensePlateNumbers'
 *      transportHolderIdReferenceNumbers: // value for 'transportHolderIdReferenceNumbers'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchShipmentsWithCustomerDetailsQuery(baseOptions?: Apollo.QueryHookOptions<SearchShipmentsWithCustomerDetailsQuery, SearchShipmentsWithCustomerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchShipmentsWithCustomerDetailsQuery, SearchShipmentsWithCustomerDetailsQueryVariables>(SearchShipmentsWithCustomerDetailsDocument, options);
      }
export function useSearchShipmentsWithCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchShipmentsWithCustomerDetailsQuery, SearchShipmentsWithCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchShipmentsWithCustomerDetailsQuery, SearchShipmentsWithCustomerDetailsQueryVariables>(SearchShipmentsWithCustomerDetailsDocument, options);
        }
export type SearchShipmentsWithCustomerDetailsQueryHookResult = ReturnType<typeof useSearchShipmentsWithCustomerDetailsQuery>;
export type SearchShipmentsWithCustomerDetailsLazyQueryHookResult = ReturnType<typeof useSearchShipmentsWithCustomerDetailsLazyQuery>;
export type SearchShipmentsWithCustomerDetailsQueryResult = Apollo.QueryResult<SearchShipmentsWithCustomerDetailsQuery, SearchShipmentsWithCustomerDetailsQueryVariables>;
export const SearchShipmentsWithGoodsHoldersForExportDocument = gql`
    query searchShipmentsWithGoodsHoldersForExport($search: String, $packlistNumbers: [String!], $salesOrderNumbers: [String!], $deliveryNoteNumbers: [String!], $goodsHolderNumbers: [String!], $proNumbers: [String!], $vendorAccessNumbers: [String!], $transportHolderNumbers: [String!], $calculatedShipmentStatusCodes: [String!], $carrierHubs: [String!], $shipToCodes: [String!], $shipToNames: [String!], $shipToCountryCodes: [String!], $shippingPointCodes: [String!], $orderTypeCodes: [String!], $actualShippedTimestampFrom: [String!], $actualShippedTimestampTo: [String!], $actualDeliveryDateFrom: [String!], $actualDeliveryDateTo: [String!], $hasTTExceptions: [String!], $transportHolderLicensePlateNumbers: [String!], $transportHolderIdReferenceNumbers: [String!], $from: Int, $size: Int) {
  searchShipmentsWithGoodsHolders(
    search: $search
    packlistNumbers: $packlistNumbers
    salesOrderNumbers: $salesOrderNumbers
    deliveryNoteNumbers: $deliveryNoteNumbers
    goodsHolderNumbers: $goodsHolderNumbers
    proNumbers: $proNumbers
    vendorAccessNumbers: $vendorAccessNumbers
    transportHolderNumbers: $transportHolderNumbers
    calculatedShipmentStatusCodes: $calculatedShipmentStatusCodes
    carrierHubs: $carrierHubs
    shipToCodes: $shipToCodes
    shipToNames: $shipToNames
    shipToCountryCodes: $shipToCountryCodes
    shippingPointCodes: $shippingPointCodes
    orderTypeCodes: $orderTypeCodes
    actualShippedTimestampFrom: $actualShippedTimestampFrom
    actualShippedTimestampTo: $actualShippedTimestampTo
    actualDeliveryDateFrom: $actualDeliveryDateFrom
    actualDeliveryDateTo: $actualDeliveryDateTo
    hasTTExceptions: $hasTTExceptions
    transportHolderLicensePlateNumbers: $transportHolderLicensePlateNumbers
    transportHolderIdReferenceNumbers: $transportHolderIdReferenceNumbers
    from: $from
    size: $size
  ) {
    iDPIndicator
    packlistNumber
    proNumbers
    vendorAccessNumbers
    transportHolderNumbers
    transportHolderLicensePlateNumbers
    transportHolderSealNumbers
    transportHolderIdReferenceNumbers
    shipmentShipToAddress {
      shipToCode
      shipToName
      countryCode
      addressOverrideIndicator
    }
    shippingPointCode
    estimatedDeliveryDate
    actualShippedTimestamp
    actualShipmentPlannedDate
    iDPPlannedTimestamp
    plannedDeliveryFromTimestamp
    plannedDeliveryToTimestamp
    plannedShipmentReadyTimestamp
    calculatedEstimatedDeliveryTimestamp
    goodsHolders {
      goodsHolderNumber
      goodsHolderTrackingNumber
      salesOrderNumber
      purchaseOrderNumber
      calculatedGoodsHolderStatusCode
      goodsHolderItems {
        deliveryNoteNumber
      }
      goodsHolderMeasures {
        grossWeight {
          measureValue
          measureUOM
        }
        grossVolume {
          measureValue
          measureUOM
        }
      }
      calculatedPackedQuantity
      calculatedPlannedQuantity
      transportHolder {
        proNumber
        transportHolderNumber
        vendorAccessNumber
        directDropIndicator
        cmrTimestamp
        sealNumber
        licensePlateNumber
        idReferenceNumber
      }
    }
    shipmentVendors {
      hubCode
      vendorCode
    }
    actualDeliveryDate
    rebooking {
      rebookingType
      iDPPlannedTimestamp
      plannedDeliveryFromTimestamp
      plannedDeliveryToTimestamp
    }
  }
}
    `;

/**
 * __useSearchShipmentsWithGoodsHoldersForExportQuery__
 *
 * To run a query within a React component, call `useSearchShipmentsWithGoodsHoldersForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchShipmentsWithGoodsHoldersForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchShipmentsWithGoodsHoldersForExportQuery({
 *   variables: {
 *      search: // value for 'search'
 *      packlistNumbers: // value for 'packlistNumbers'
 *      salesOrderNumbers: // value for 'salesOrderNumbers'
 *      deliveryNoteNumbers: // value for 'deliveryNoteNumbers'
 *      goodsHolderNumbers: // value for 'goodsHolderNumbers'
 *      proNumbers: // value for 'proNumbers'
 *      vendorAccessNumbers: // value for 'vendorAccessNumbers'
 *      transportHolderNumbers: // value for 'transportHolderNumbers'
 *      calculatedShipmentStatusCodes: // value for 'calculatedShipmentStatusCodes'
 *      carrierHubs: // value for 'carrierHubs'
 *      shipToCodes: // value for 'shipToCodes'
 *      shipToNames: // value for 'shipToNames'
 *      shipToCountryCodes: // value for 'shipToCountryCodes'
 *      shippingPointCodes: // value for 'shippingPointCodes'
 *      orderTypeCodes: // value for 'orderTypeCodes'
 *      actualShippedTimestampFrom: // value for 'actualShippedTimestampFrom'
 *      actualShippedTimestampTo: // value for 'actualShippedTimestampTo'
 *      actualDeliveryDateFrom: // value for 'actualDeliveryDateFrom'
 *      actualDeliveryDateTo: // value for 'actualDeliveryDateTo'
 *      hasTTExceptions: // value for 'hasTTExceptions'
 *      transportHolderLicensePlateNumbers: // value for 'transportHolderLicensePlateNumbers'
 *      transportHolderIdReferenceNumbers: // value for 'transportHolderIdReferenceNumbers'
 *      from: // value for 'from'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useSearchShipmentsWithGoodsHoldersForExportQuery(baseOptions?: Apollo.QueryHookOptions<SearchShipmentsWithGoodsHoldersForExportQuery, SearchShipmentsWithGoodsHoldersForExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchShipmentsWithGoodsHoldersForExportQuery, SearchShipmentsWithGoodsHoldersForExportQueryVariables>(SearchShipmentsWithGoodsHoldersForExportDocument, options);
      }
export function useSearchShipmentsWithGoodsHoldersForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchShipmentsWithGoodsHoldersForExportQuery, SearchShipmentsWithGoodsHoldersForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchShipmentsWithGoodsHoldersForExportQuery, SearchShipmentsWithGoodsHoldersForExportQueryVariables>(SearchShipmentsWithGoodsHoldersForExportDocument, options);
        }
export type SearchShipmentsWithGoodsHoldersForExportQueryHookResult = ReturnType<typeof useSearchShipmentsWithGoodsHoldersForExportQuery>;
export type SearchShipmentsWithGoodsHoldersForExportLazyQueryHookResult = ReturnType<typeof useSearchShipmentsWithGoodsHoldersForExportLazyQuery>;
export type SearchShipmentsWithGoodsHoldersForExportQueryResult = Apollo.QueryResult<SearchShipmentsWithGoodsHoldersForExportQuery, SearchShipmentsWithGoodsHoldersForExportQueryVariables>;
export const GetShipmentTrackAndTraceDocument = gql`
    query getShipmentTrackAndTrace($packlistNumber: String!) {
  getShipmentTrackAndTrace(packlistNumber: $packlistNumber) {
    sourceSystemName
    goodsHolderNumbers
    count
    event {
      eventTimestamp
      carrierStatusDescription
      intermediateStatusCode
      intermediateStatusDescription
      isException
    }
  }
}
    `;

/**
 * __useGetShipmentTrackAndTraceQuery__
 *
 * To run a query within a React component, call `useGetShipmentTrackAndTraceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentTrackAndTraceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentTrackAndTraceQuery({
 *   variables: {
 *      packlistNumber: // value for 'packlistNumber'
 *   },
 * });
 */
export function useGetShipmentTrackAndTraceQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentTrackAndTraceQuery, GetShipmentTrackAndTraceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentTrackAndTraceQuery, GetShipmentTrackAndTraceQueryVariables>(GetShipmentTrackAndTraceDocument, options);
      }
export function useGetShipmentTrackAndTraceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentTrackAndTraceQuery, GetShipmentTrackAndTraceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentTrackAndTraceQuery, GetShipmentTrackAndTraceQueryVariables>(GetShipmentTrackAndTraceDocument, options);
        }
export type GetShipmentTrackAndTraceQueryHookResult = ReturnType<typeof useGetShipmentTrackAndTraceQuery>;
export type GetShipmentTrackAndTraceLazyQueryHookResult = ReturnType<typeof useGetShipmentTrackAndTraceLazyQuery>;
export type GetShipmentTrackAndTraceQueryResult = Apollo.QueryResult<GetShipmentTrackAndTraceQuery, GetShipmentTrackAndTraceQueryVariables>;